import * as i0 from '@angular/core';
import { EventEmitter, Directive, Inject, Input, Output, Injectable, LOCALE_ID, Pipe, Component, HostListener, InjectionToken, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { DOCUMENT, formatDate, CommonModule, I18nPluralPipe } from '@angular/common';
import { Subject, Observable, of, timer, BehaviorSubject, interval } from 'rxjs';
import { takeUntil, switchMap, startWith, switchMapTo, map } from 'rxjs/operators';
import { positionElements } from 'positioning';
import { validateEvents as validateEvents$1, getMonthView, getWeekViewHeader, getWeekView } from 'calendar-utils';
const _c0 = (a0, a1) => ({
  event: a0,
  trackByActionId: a1
});
const _c1 = a0 => ({
  action: a0
});
function CalendarEventActionsComponent_ng_template_0_span_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵpipe(1, "calendarA11y");
    i0.ɵɵlistener("mwlClick", function CalendarEventActionsComponent_ng_template_0_span_0_a_1_Template_a_mwlClick_0_listener($event) {
      const action_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const event_r3 = i0.ɵɵnextContext(2).event;
      return i0.ɵɵresetView(action_r2.onClick({
        event: event_r3,
        sourceEvent: $event
      }));
    })("mwlKeydownEnter", function CalendarEventActionsComponent_ng_template_0_span_0_a_1_Template_a_mwlKeydownEnter_0_listener($event) {
      const action_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const event_r3 = i0.ɵɵnextContext(2).event;
      return i0.ɵɵresetView(action_r2.onClick({
        event: event_r3,
        sourceEvent: $event
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", action_r2.cssClass)("innerHtml", action_r2.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 3, i0.ɵɵpureFunction1(6, _c1, action_r2), "actionButtonLabel"));
  }
}
function CalendarEventActionsComponent_ng_template_0_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtemplate(1, CalendarEventActionsComponent_ng_template_0_span_0_a_1_Template, 2, 8, "a", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const event_r3 = ctx_r3.event;
    const trackByActionId_r5 = ctx_r3.trackByActionId;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", event_r3.actions)("ngForTrackBy", trackByActionId_r5);
  }
}
function CalendarEventActionsComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarEventActionsComponent_ng_template_0_span_0_Template, 2, 2, "span", 2);
  }
  if (rf & 2) {
    const event_r3 = ctx.event;
    i0.ɵɵproperty("ngIf", event_r3.actions);
  }
}
function CalendarEventActionsComponent_ng_template_2_Template(rf, ctx) {}
const _c2 = (a0, a1) => ({
  event: a0,
  view: a1
});
const _c3 = () => ({});
function CalendarEventTitleComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
    i0.ɵɵpipe(1, "calendarEventTitle");
    i0.ɵɵpipe(2, "calendarA11y");
  }
  if (rf & 2) {
    const event_r1 = ctx.event;
    const view_r2 = ctx.view;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind3(1, 2, event_r1.title, view_r2, event_r1), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind2(2, 6, i0.ɵɵpureFunction0(9, _c3), "hideEventTitle"));
  }
}
function CalendarEventTitleComponent_ng_template_2_Template(rf, ctx) {}
const _c4 = (a0, a1, a2) => ({
  contents: a0,
  placement: a1,
  event: a2
});
function CalendarTooltipWindowComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 3)(2, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const contents_r1 = ctx.contents;
    const placement_r2 = ctx.placement;
    i0.ɵɵproperty("ngClass", "cal-tooltip-" + placement_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", contents_r1, i0.ɵɵsanitizeHtml);
  }
}
function CalendarTooltipWindowComponent_ng_template_2_Template(rf, ctx) {}
const _c5 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) => ({
  day: a0,
  openDay: a1,
  locale: a2,
  tooltipPlacement: a3,
  highlightDay: a4,
  unhighlightDay: a5,
  eventClicked: a6,
  tooltipTemplate: a7,
  tooltipAppendToBody: a8,
  tooltipDelay: a9,
  trackByEventId: a10,
  validateDrag: a11
});
const _c6 = (a0, a1) => ({
  day: a0,
  locale: a1
});
const _c7 = a0 => ({
  backgroundColor: a0
});
const _c8 = (a0, a1) => ({
  event: a0,
  draggedFrom: a1
});
const _c9 = (a0, a1) => ({
  x: a0,
  y: a1
});
const _c10 = () => ({
  delay: 300,
  delta: 30
});
function CalendarMonthCellComponent_ng_template_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r1 = i0.ɵɵnextContext().day;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(day_r1.badgeTotal);
  }
}
function CalendarMonthCellComponent_ng_template_0_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "calendarEventTitle");
    i0.ɵɵpipe(2, "calendarA11y");
    i0.ɵɵlistener("mouseenter", function CalendarMonthCellComponent_ng_template_0_div_7_div_1_Template_div_mouseenter_0_listener() {
      const event_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const highlightDay_r4 = i0.ɵɵnextContext(2).highlightDay;
      return i0.ɵɵresetView(highlightDay_r4.emit({
        event: event_r3
      }));
    })("mouseleave", function CalendarMonthCellComponent_ng_template_0_div_7_div_1_Template_div_mouseleave_0_listener() {
      const event_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const unhighlightDay_r5 = i0.ɵɵnextContext(2).unhighlightDay;
      return i0.ɵɵresetView(unhighlightDay_r5.emit({
        event: event_r3
      }));
    })("mwlClick", function CalendarMonthCellComponent_ng_template_0_div_7_div_1_Template_div_mwlClick_0_listener($event) {
      const event_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const eventClicked_r6 = i0.ɵɵnextContext(2).eventClicked;
      return i0.ɵɵresetView(eventClicked_r6.emit({
        event: event_r3,
        sourceEvent: $event
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r3 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    const day_r1 = ctx_r6.day;
    const tooltipPlacement_r8 = ctx_r6.tooltipPlacement;
    const tooltipTemplate_r9 = ctx_r6.tooltipTemplate;
    const tooltipAppendToBody_r10 = ctx_r6.tooltipAppendToBody;
    const tooltipDelay_r11 = ctx_r6.tooltipDelay;
    const validateDrag_r12 = ctx_r6.validateDrag;
    i0.ɵɵclassProp("cal-draggable", event_r3.draggable);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(22, _c7, event_r3.color == null ? null : event_r3.color.primary))("ngClass", event_r3 == null ? null : event_r3.cssClass)("mwlCalendarTooltip", i0.ɵɵpipeBind3(1, 15, event_r3.title, "monthTooltip", event_r3))("tooltipPlacement", tooltipPlacement_r8)("tooltipEvent", event_r3)("tooltipTemplate", tooltipTemplate_r9)("tooltipAppendToBody", tooltipAppendToBody_r10)("tooltipDelay", tooltipDelay_r11)("dropData", i0.ɵɵpureFunction2(24, _c8, event_r3, day_r1))("dragAxis", i0.ɵɵpureFunction2(27, _c9, event_r3.draggable, event_r3.draggable))("validateDrag", validateDrag_r12)("touchStartLongPress", i0.ɵɵpureFunction0(30, _c10));
    i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind2(2, 19, i0.ɵɵpureFunction0(31, _c3), "hideMonthCellEvents"));
  }
}
function CalendarMonthCellComponent_ng_template_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, CalendarMonthCellComponent_ng_template_0_div_7_div_1_Template, 3, 32, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const day_r1 = ctx_r6.day;
    const trackByEventId_r13 = ctx_r6.trackByEventId;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", day_r1.events)("ngForTrackBy", trackByEventId_r13);
  }
}
function CalendarMonthCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "calendarA11y");
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtemplate(3, CalendarMonthCellComponent_ng_template_0_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "calendarDate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(7, CalendarMonthCellComponent_ng_template_0_div_7_Template, 2, 2, "div", 6);
  }
  if (rf & 2) {
    const day_r1 = ctx.day;
    const locale_r14 = ctx.locale;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 4, i0.ɵɵpureFunction2(11, _c6, day_r1, locale_r14), "monthCell"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", day_r1.badgeTotal > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(6, 7, day_r1.date, "monthViewDayNumber", locale_r14));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", day_r1.events.length > 0);
  }
}
function CalendarMonthCellComponent_ng_template_2_Template(rf, ctx) {}
const _c11 = (a0, a1, a2, a3, a4) => ({
  events: a0,
  eventClicked: a1,
  isOpen: a2,
  trackByEventId: a3,
  validateDrag: a4
});
const _c12 = (a0, a1) => ({
  date: a0,
  locale: a1
});
const _c13 = a0 => ({
  event: a0
});
const _c14 = (a0, a1) => ({
  event: a0,
  locale: a1
});
function CalendarOpenDayEventsComponent_ng_template_0_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵtext(2, " ");
    i0.ɵɵelementStart(3, "mwl-calendar-event-title", 9);
    i0.ɵɵpipe(4, "calendarA11y");
    i0.ɵɵlistener("mwlClick", function CalendarOpenDayEventsComponent_ng_template_0_div_0_div_5_Template_mwl_calendar_event_title_mwlClick_3_listener($event) {
      const event_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const eventClicked_r3 = i0.ɵɵnextContext(2).eventClicked;
      return i0.ɵɵresetView(eventClicked_r3.emit({
        event: event_r2,
        sourceEvent: $event
      }));
    })("mwlKeydownEnter", function CalendarOpenDayEventsComponent_ng_template_0_div_0_div_5_Template_mwl_calendar_event_title_mwlKeydownEnter_3_listener($event) {
      const event_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const eventClicked_r3 = i0.ɵɵnextContext(2).eventClicked;
      return i0.ɵɵresetView(eventClicked_r3.emit({
        event: event_r2,
        sourceEvent: $event
      }));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " ");
    i0.ɵɵelement(6, "mwl-calendar-event-actions", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r2 = ctx.$implicit;
    const validateDrag_r4 = i0.ɵɵnextContext(2).validateDrag;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cal-draggable", event_r2.draggable);
    i0.ɵɵproperty("ngClass", event_r2 == null ? null : event_r2.cssClass)("dropData", i0.ɵɵpureFunction1(16, _c13, event_r2))("dragAxis", i0.ɵɵpureFunction2(18, _c9, event_r2.draggable, event_r2.draggable))("validateDrag", validateDrag_r4)("touchStartLongPress", i0.ɵɵpureFunction0(21, _c10));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(22, _c7, event_r2.color == null ? null : event_r2.color.primary));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("event", event_r2)("customTemplate", ctx_r4.eventTitleTemplate);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 13, i0.ɵɵpureFunction2(24, _c14, event_r2, ctx_r4.locale), "eventDescription"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("event", event_r2)("customTemplate", ctx_r4.eventActionsTemplate);
  }
}
function CalendarOpenDayEventsComponent_ng_template_0_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "span", 4);
    i0.ɵɵpipe(2, "calendarA11y");
    i0.ɵɵelement(3, "span", 5);
    i0.ɵɵpipe(4, "calendarA11y");
    i0.ɵɵtemplate(5, CalendarOpenDayEventsComponent_ng_template_0_div_0_div_5_Template, 7, 27, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const events_r7 = ctx_r5.events;
    const trackByEventId_r8 = ctx_r5.trackByEventId;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@collapse", undefined);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 5, i0.ɵɵpureFunction2(11, _c12, ctx_r4.date, ctx_r4.locale), "openDayEventsAlert"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 8, i0.ɵɵpureFunction2(14, _c12, ctx_r4.date, ctx_r4.locale), "openDayEventsLandmark"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", events_r7)("ngForTrackBy", trackByEventId_r8);
  }
}
function CalendarOpenDayEventsComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarOpenDayEventsComponent_ng_template_0_div_0_Template, 6, 17, "div", 2);
  }
  if (rf & 2) {
    const isOpen_r9 = ctx.isOpen;
    i0.ɵɵproperty("ngIf", isOpen_r9);
  }
}
function CalendarOpenDayEventsComponent_ng_template_2_Template(rf, ctx) {}
const _c15 = (a0, a1, a2) => ({
  days: a0,
  locale: a1,
  trackByWeekDayHeaderDate: a2
});
function CalendarMonthViewHeaderComponent_ng_template_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function CalendarMonthViewHeaderComponent_ng_template_0_div_1_Template_div_click_0_listener($event) {
      const day_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.columnHeaderClicked.emit({
        isoDayNumber: day_r2.day,
        sourceEvent: $event
      }));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "calendarDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r2 = ctx.$implicit;
    const locale_r4 = i0.ɵɵnextContext().locale;
    i0.ɵɵclassProp("cal-past", day_r2.isPast)("cal-today", day_r2.isToday)("cal-future", day_r2.isFuture)("cal-weekend", day_r2.isWeekend);
    i0.ɵɵproperty("ngClass", day_r2.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 10, day_r2.date, "monthViewColumnHeader", locale_r4), " ");
  }
}
function CalendarMonthViewHeaderComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CalendarMonthViewHeaderComponent_ng_template_0_div_1_Template, 3, 14, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const days_r5 = ctx.days;
    const trackByWeekDayHeaderDate_r6 = ctx.trackByWeekDayHeaderDate;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", days_r5)("ngForTrackBy", trackByWeekDayHeaderDate_r6);
  }
}
function CalendarMonthViewHeaderComponent_ng_template_2_Template(rf, ctx) {}
function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-month-cell", 7);
    i0.ɵɵpipe(1, "calendarA11y");
    i0.ɵɵlistener("mwlClick", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_mwlClick_0_listener($event) {
      const day_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.dayClicked.emit({
        day: day_r3,
        sourceEvent: $event
      }));
    })("mwlKeydownEnter", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_mwlKeydownEnter_0_listener($event) {
      const day_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.dayClicked.emit({
        day: day_r3,
        sourceEvent: $event
      }));
    })("highlightDay", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_highlightDay_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.toggleDayHighlight($event.event, true));
    })("unhighlightDay", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_unhighlightDay_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.toggleDayHighlight($event.event, false));
    })("drop", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_drop_0_listener($event) {
      const day_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.eventDropped(day_r3, $event.dropData.event, $event.dropData.draggedFrom));
    })("eventClicked", function CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template_mwl_calendar_month_cell_eventClicked_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.eventClicked.emit({
        event: $event.event,
        sourceEvent: $event.sourceEvent
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", day_r3 == null ? null : day_r3.cssClass)("day", day_r3)("openDay", ctx_r3.openDay)("locale", ctx_r3.locale)("tooltipPlacement", ctx_r3.tooltipPlacement)("tooltipAppendToBody", ctx_r3.tooltipAppendToBody)("tooltipTemplate", ctx_r3.tooltipTemplate)("tooltipDelay", ctx_r3.tooltipDelay)("customTemplate", ctx_r3.cellTemplate)("ngStyle", i0.ɵɵpureFunction1(15, _c7, day_r3.backgroundColor))("clickListenerDisabled", ctx_r3.dayClicked.observers.length === 0);
    i0.ɵɵattribute("tabindex", i0.ɵɵpipeBind2(1, 12, i0.ɵɵpureFunction0(17, _c3), "monthCellTabIndex"));
  }
}
function CalendarMonthViewComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 4);
    i0.ɵɵtemplate(2, CalendarMonthViewComponent_div_3_mwl_calendar_month_cell_2_Template, 2, 18, "mwl-calendar-month-cell", 5);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mwl-calendar-open-day-events", 6);
    i0.ɵɵlistener("eventClicked", function CalendarMonthViewComponent_div_3_Template_mwl_calendar_open_day_events_eventClicked_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.eventClicked.emit({
        event: $event.event,
        sourceEvent: $event.sourceEvent
      }));
    })("drop", function CalendarMonthViewComponent_div_3_Template_mwl_calendar_open_day_events_drop_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.eventDropped(ctx_r3.openDay, $event.dropData.event, $event.dropData.draggedFrom));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rowIndex_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 9, ctx_r3.view.days, rowIndex_r5, rowIndex_r5 + ctx_r3.view.totalDaysVisibleInWeek))("ngForTrackBy", ctx_r3.trackByDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("locale", ctx_r3.locale)("isOpen", ctx_r3.openRowIndex === rowIndex_r5)("events", ctx_r3.openDay == null ? null : ctx_r3.openDay.events)("date", ctx_r3.openDay == null ? null : ctx_r3.openDay.date)("customTemplate", ctx_r3.openDayEventsTemplate)("eventTitleTemplate", ctx_r3.eventTitleTemplate)("eventActionsTemplate", ctx_r3.eventActionsTemplate);
  }
}
const _c16 = (a0, a1, a2, a3, a4, a5) => ({
  days: a0,
  locale: a1,
  dayHeaderClicked: a2,
  eventDropped: a3,
  dragEnter: a4,
  trackByWeekDayHeaderDate: a5
});
function CalendarWeekViewHeaderComponent_ng_template_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("mwlClick", function CalendarWeekViewHeaderComponent_ng_template_0_div_1_Template_div_mwlClick_0_listener($event) {
      const day_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const dayHeaderClicked_r3 = i0.ɵɵnextContext().dayHeaderClicked;
      return i0.ɵɵresetView(dayHeaderClicked_r3.emit({
        day: day_r2,
        sourceEvent: $event
      }));
    })("drop", function CalendarWeekViewHeaderComponent_ng_template_0_div_1_Template_div_drop_0_listener($event) {
      const day_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const eventDropped_r4 = i0.ɵɵnextContext().eventDropped;
      return i0.ɵɵresetView(eventDropped_r4.emit({
        event: $event.dropData.event,
        newStart: day_r2.date
      }));
    })("dragEnter", function CalendarWeekViewHeaderComponent_ng_template_0_div_1_Template_div_dragEnter_0_listener() {
      const day_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const dragEnter_r5 = i0.ɵɵnextContext().dragEnter;
      return i0.ɵɵresetView(dragEnter_r5.emit({
        date: day_r2.date
      }));
    });
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "calendarDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "calendarDate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r2 = ctx.$implicit;
    const locale_r6 = i0.ɵɵnextContext().locale;
    i0.ɵɵclassProp("cal-past", day_r2.isPast)("cal-today", day_r2.isToday)("cal-future", day_r2.isFuture)("cal-weekend", day_r2.isWeekend);
    i0.ɵɵproperty("ngClass", day_r2.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(3, 11, day_r2.date, "weekViewColumnHeader", locale_r6));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 15, day_r2.date, "weekViewColumnSubHeader", locale_r6));
  }
}
function CalendarWeekViewHeaderComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CalendarWeekViewHeaderComponent_ng_template_0_div_1_Template, 8, 19, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const days_r7 = ctx.days;
    const trackByWeekDayHeaderDate_r8 = ctx.trackByWeekDayHeaderDate;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", days_r7)("ngForTrackBy", trackByWeekDayHeaderDate_r8);
  }
}
function CalendarWeekViewHeaderComponent_ng_template_2_Template(rf, ctx) {}
const _c17 = (a0, a1, a2, a3, a4, a5, a6, a7, a8) => ({
  weekEvent: a0,
  tooltipPlacement: a1,
  eventClicked: a2,
  tooltipTemplate: a3,
  tooltipAppendToBody: a4,
  tooltipDisabled: a5,
  tooltipDelay: a6,
  column: a7,
  daysInWeek: a8
});
const _c18 = (a0, a1, a2) => ({
  color: a0,
  backgroundColor: a1,
  borderColor: a2
});
function CalendarWeekViewEventComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "calendarEventTitle");
    i0.ɵɵpipe(2, "calendarA11y");
    i0.ɵɵlistener("mwlClick", function CalendarWeekViewEventComponent_ng_template_0_Template_div_mwlClick_0_listener($event) {
      const eventClicked_r2 = i0.ɵɵrestoreView(_r1).eventClicked;
      return i0.ɵɵresetView(eventClicked_r2.emit({
        sourceEvent: $event
      }));
    })("mwlKeydownEnter", function CalendarWeekViewEventComponent_ng_template_0_Template_div_mwlKeydownEnter_0_listener($event) {
      const eventClicked_r2 = i0.ɵɵrestoreView(_r1).eventClicked;
      return i0.ɵɵresetView(eventClicked_r2.emit({
        sourceEvent: $event
      }));
    });
    i0.ɵɵelement(3, "mwl-calendar-event-actions", 3);
    i0.ɵɵtext(4, " ");
    i0.ɵɵelement(5, "mwl-calendar-event-title", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const weekEvent_r3 = ctx.weekEvent;
    const tooltipPlacement_r4 = ctx.tooltipPlacement;
    const tooltipTemplate_r5 = ctx.tooltipTemplate;
    const tooltipAppendToBody_r6 = ctx.tooltipAppendToBody;
    const tooltipDisabled_r7 = ctx.tooltipDisabled;
    const tooltipDelay_r8 = ctx.tooltipDelay;
    const daysInWeek_r9 = ctx.daysInWeek;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(20, _c18, weekEvent_r3.event.color == null ? null : weekEvent_r3.event.color.secondaryText, weekEvent_r3.event.color == null ? null : weekEvent_r3.event.color.secondary, weekEvent_r3.event.color == null ? null : weekEvent_r3.event.color.primary))("mwlCalendarTooltip", !tooltipDisabled_r7 ? i0.ɵɵpipeBind3(1, 13, weekEvent_r3.event.title, daysInWeek_r9 === 1 ? "dayTooltip" : "weekTooltip", weekEvent_r3.tempEvent || weekEvent_r3.event) : "")("tooltipPlacement", tooltipPlacement_r4)("tooltipEvent", weekEvent_r3.tempEvent || weekEvent_r3.event)("tooltipTemplate", tooltipTemplate_r5)("tooltipAppendToBody", tooltipAppendToBody_r6)("tooltipDelay", tooltipDelay_r8);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 17, i0.ɵɵpureFunction2(24, _c14, weekEvent_r3.tempEvent || weekEvent_r3.event, ctx_r9.locale), "eventDescription"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("event", weekEvent_r3.tempEvent || weekEvent_r3.event)("customTemplate", ctx_r9.eventActionsTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("event", weekEvent_r3.tempEvent || weekEvent_r3.event)("customTemplate", ctx_r9.eventTitleTemplate)("view", daysInWeek_r9 === 1 ? "day" : "week");
  }
}
function CalendarWeekViewEventComponent_ng_template_2_Template(rf, ctx) {}
const _c19 = (a0, a1, a2, a3, a4) => ({
  segment: a0,
  locale: a1,
  segmentHeight: a2,
  isTimeLabel: a3,
  daysInWeek: a4
});
function CalendarWeekViewHourSegmentComponent_ng_template_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "calendarDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const segment_r2 = ctx_r0.segment;
    const locale_r3 = ctx_r0.locale;
    const daysInWeek_r4 = ctx_r0.daysInWeek;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(2, 1, segment_r2.displayDate, daysInWeek_r4 === 1 ? "dayViewHour" : "weekViewHour", locale_r3), " ");
  }
}
function CalendarWeekViewHourSegmentComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "calendarA11y");
    i0.ɵɵtemplate(2, CalendarWeekViewHourSegmentComponent_ng_template_0_div_2_Template, 3, 5, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const segment_r2 = ctx.segment;
    const segmentHeight_r5 = ctx.segmentHeight;
    const isTimeLabel_r6 = ctx.isTimeLabel;
    const daysInWeek_r4 = ctx.daysInWeek;
    i0.ɵɵstyleProp("height", segmentHeight_r5, "px");
    i0.ɵɵclassProp("cal-hour-start", segment_r2.isStart)("cal-after-hour-start", !segment_r2.isStart);
    i0.ɵɵproperty("ngClass", segment_r2.cssClass);
    i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind2(1, 9, i0.ɵɵpureFunction0(12, _c3), daysInWeek_r4 === 1 ? "hideDayHourSegment" : "hideWeekHourSegment"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", isTimeLabel_r6);
  }
}
function CalendarWeekViewHourSegmentComponent_ng_template_2_Template(rf, ctx) {}
const _c20 = (a0, a1, a2, a3, a4, a5, a6) => ({
  columnDate: a0,
  dayStartHour: a1,
  dayStartMinute: a2,
  dayEndHour: a3,
  dayEndMinute: a4,
  isVisible: a5,
  topPx: a6
});
function CalendarWeekViewCurrentTimeMarkerComponent_ng_template_0_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
  if (rf & 2) {
    const topPx_r1 = i0.ɵɵnextContext().topPx;
    i0.ɵɵstyleProp("top", topPx_r1, "px");
  }
}
function CalendarWeekViewCurrentTimeMarkerComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CalendarWeekViewCurrentTimeMarkerComponent_ng_template_0_div_0_Template, 1, 2, "div", 2);
  }
  if (rf & 2) {
    const isVisible_r2 = ctx.isVisible;
    i0.ɵɵproperty("ngIf", isVisible_r2);
  }
}
function CalendarWeekViewCurrentTimeMarkerComponent_ng_template_2_Template(rf, ctx) {}
const _c21 = (a0, a1) => ({
  left: a0,
  right: a1
});
const _c22 = (a0, a1) => ({
  event: a0,
  calendarId: a1
});
const _c23 = a0 => ({
  x: a0
});
const _c24 = () => ({
  left: true
});
const _c25 = () => ({
  right: true
});
const _c26 = (a0, a1, a2, a3) => ({
  left: a0,
  right: a1,
  top: a2,
  bottom: a3
});
const _c27 = () => ({
  left: true,
  top: true
});
const _c28 = () => ({
  right: true,
  bottom: true
});
function CalendarWeekViewComponent_div_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CalendarWeekViewComponent_div_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("drop", function CalendarWeekViewComponent_div_2_div_5_Template_div_drop_0_listener($event) {
      const day_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.eventDropped($event, day_r5.date, true));
    })("dragEnter", function CalendarWeekViewComponent_div_2_div_5_Template_div_dragEnter_0_listener() {
      const day_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dateDragEnter(day_r5.date));
    });
    i0.ɵɵelementEnd();
  }
}
function CalendarWeekViewComponent_div_2_div_6_div_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("resizeEdges", i0.ɵɵpureFunction0(1, _c24));
  }
}
function CalendarWeekViewComponent_div_2_div_6_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 25);
  }
  if (rf & 2) {
    i0.ɵɵproperty("resizeEdges", i0.ɵɵpureFunction0(1, _c25));
  }
}
function CalendarWeekViewComponent_div_2_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20, 3);
    i0.ɵɵlistener("resizeStart", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_resizeStart_0_listener($event) {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      i0.ɵɵnextContext();
      const eventRowContainer_r8 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.allDayEventResizeStarted(eventRowContainer_r8, allDayEvent_r7, $event));
    })("resizing", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_resizing_0_listener($event) {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.allDayEventResizing(allDayEvent_r7, $event, ctx_r2.dayColumnWidth));
    })("resizeEnd", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_resizeEnd_0_listener() {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.allDayEventResizeEnded(allDayEvent_r7));
    })("dragStart", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_dragStart_0_listener() {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const event_r9 = i0.ɵɵreference(1);
      i0.ɵɵnextContext();
      const eventRowContainer_r8 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dragStarted(eventRowContainer_r8, event_r9, allDayEvent_r7, false));
    })("dragging", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_dragging_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.allDayEventDragMove());
    })("dragEnd", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_div_dragEnd_0_listener($event) {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dragEnded(allDayEvent_r7, $event, ctx_r2.dayColumnWidth));
    });
    i0.ɵɵtemplate(2, CalendarWeekViewComponent_div_2_div_6_div_2_div_2_Template, 1, 2, "div", 21);
    i0.ɵɵelementStart(3, "mwl-calendar-week-view-event", 22);
    i0.ɵɵlistener("eventClicked", function CalendarWeekViewComponent_div_2_div_6_div_2_Template_mwl_calendar_week_view_event_eventClicked_3_listener($event) {
      const allDayEvent_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.eventClicked.emit({
        event: allDayEvent_r7.event,
        sourceEvent: $event.sourceEvent
      }));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CalendarWeekViewComponent_div_2_div_6_div_2_div_4_Template, 1, 2, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const allDayEvent_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("width", 100 / ctx_r2.days.length * allDayEvent_r7.span, "%")("margin-left", ctx_r2.rtl ? null : 100 / ctx_r2.days.length * allDayEvent_r7.offset, "%")("margin-right", ctx_r2.rtl ? 100 / ctx_r2.days.length * allDayEvent_r7.offset : null, "%");
    i0.ɵɵclassProp("cal-draggable", allDayEvent_r7.event.draggable && ctx_r2.allDayEventResizes.size === 0)("cal-starts-within-week", !allDayEvent_r7.startsBeforeWeek)("cal-ends-within-week", !allDayEvent_r7.endsAfterWeek);
    i0.ɵɵproperty("ngClass", allDayEvent_r7.event == null ? null : allDayEvent_r7.event.cssClass)("resizeCursors", ctx_r2.resizeCursors)("resizeSnapGrid", i0.ɵɵpureFunction2(33, _c21, ctx_r2.dayColumnWidth, ctx_r2.dayColumnWidth))("validateResize", ctx_r2.validateResize)("dropData", i0.ɵɵpureFunction2(36, _c22, allDayEvent_r7.event, ctx_r2.calendarId))("dragAxis", i0.ɵɵpureFunction2(39, _c9, allDayEvent_r7.event.draggable && ctx_r2.allDayEventResizes.size === 0, !ctx_r2.snapDraggedEvents && allDayEvent_r7.event.draggable && ctx_r2.allDayEventResizes.size === 0))("dragSnapGrid", ctx_r2.snapDraggedEvents ? i0.ɵɵpureFunction1(42, _c23, ctx_r2.dayColumnWidth) : i0.ɵɵpureFunction0(44, _c3))("validateDrag", ctx_r2.validateDrag)("touchStartLongPress", i0.ɵɵpureFunction0(45, _c10));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (allDayEvent_r7.event == null ? null : allDayEvent_r7.event.resizable == null ? null : allDayEvent_r7.event.resizable.beforeStart) && !allDayEvent_r7.startsBeforeWeek);
    i0.ɵɵadvance();
    i0.ɵɵproperty("locale", ctx_r2.locale)("weekEvent", allDayEvent_r7)("tooltipPlacement", ctx_r2.tooltipPlacement)("tooltipTemplate", ctx_r2.tooltipTemplate)("tooltipAppendToBody", ctx_r2.tooltipAppendToBody)("tooltipDelay", ctx_r2.tooltipDelay)("customTemplate", ctx_r2.eventTemplate)("eventTitleTemplate", ctx_r2.eventTitleTemplate)("eventActionsTemplate", ctx_r2.eventActionsTemplate)("daysInWeek", ctx_r2.daysInWeek);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (allDayEvent_r7.event == null ? null : allDayEvent_r7.event.resizable == null ? null : allDayEvent_r7.event.resizable.afterEnd) && !allDayEvent_r7.endsAfterWeek);
  }
}
function CalendarWeekViewComponent_div_2_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 2);
    i0.ɵɵtemplate(2, CalendarWeekViewComponent_div_2_div_6_div_2_Template, 5, 46, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eventRow_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", eventRow_r10.row)("ngForTrackBy", ctx_r2.trackByWeekAllDayEvent);
  }
}
function CalendarWeekViewComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 1);
    i0.ɵɵlistener("dragEnter", function CalendarWeekViewComponent_div_2_Template_div_dragEnter_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragEnter("allDay"));
    })("dragLeave", function CalendarWeekViewComponent_div_2_Template_div_dragLeave_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragLeave("allDay"));
    });
    i0.ɵɵelementStart(2, "div", 10)(3, "div", 13);
    i0.ɵɵtemplate(4, CalendarWeekViewComponent_div_2_ng_container_4_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CalendarWeekViewComponent_div_2_div_5_Template, 1, 0, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CalendarWeekViewComponent_div_2_div_6_Template, 3, 2, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.allDayEventsLabelTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.days)("ngForTrackBy", ctx_r2.trackByWeekDayHeaderDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.view.allDayEventRows)("ngForTrackBy", ctx_r2.trackById);
  }
}
function CalendarWeekViewComponent_div_4_div_1_mwl_calendar_week_view_hour_segment_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mwl-calendar-week-view-hour-segment", 29);
  }
  if (rf & 2) {
    const segment_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("height", ctx_r2.hourSegmentHeight, "px");
    i0.ɵɵproperty("segment", segment_r11)("segmentHeight", ctx_r2.hourSegmentHeight)("locale", ctx_r2.locale)("customTemplate", ctx_r2.hourSegmentTemplate)("isTimeLabel", true)("daysInWeek", ctx_r2.daysInWeek);
  }
}
function CalendarWeekViewComponent_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, CalendarWeekViewComponent_div_4_div_1_mwl_calendar_week_view_hour_segment_1_Template, 1, 8, "mwl-calendar-week-view-hour-segment", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r12 = ctx.$implicit;
    const odd_r13 = ctx.odd;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("cal-hour-odd", odd_r13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", hour_r12.segments)("ngForTrackBy", ctx_r2.trackByHourSegment);
  }
}
function CalendarWeekViewComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, CalendarWeekViewComponent_div_4_div_1_Template, 2, 4, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.view.hourColumns[0].hours)("ngForTrackBy", ctx_r2.trackByHour);
  }
}
function CalendarWeekViewComponent_div_7_div_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("resizeEdges", i0.ɵɵpureFunction0(1, _c27));
  }
}
function CalendarWeekViewComponent_div_7_div_3_ng_template_3_Template(rf, ctx) {}
function CalendarWeekViewComponent_div_7_div_3_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-week-view-event", 36);
    i0.ɵɵlistener("eventClicked", function CalendarWeekViewComponent_div_7_div_3_ng_template_4_Template_mwl_calendar_week_view_event_eventClicked_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const timeEvent_r15 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.eventClicked.emit({
        event: timeEvent_r15.event,
        sourceEvent: $event.sourceEvent
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timeEvent_r15 = i0.ɵɵnextContext().$implicit;
    const column_r19 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("locale", ctx_r2.locale)("weekEvent", timeEvent_r15)("tooltipPlacement", ctx_r2.tooltipPlacement)("tooltipTemplate", ctx_r2.tooltipTemplate)("tooltipAppendToBody", ctx_r2.tooltipAppendToBody)("tooltipDisabled", ctx_r2.dragActive || ctx_r2.timeEventResizes.size > 0)("tooltipDelay", ctx_r2.tooltipDelay)("customTemplate", ctx_r2.eventTemplate)("eventTitleTemplate", ctx_r2.eventTitleTemplate)("eventActionsTemplate", ctx_r2.eventActionsTemplate)("column", column_r19)("daysInWeek", ctx_r2.daysInWeek);
  }
}
function CalendarWeekViewComponent_div_7_div_3_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 25);
  }
  if (rf & 2) {
    i0.ɵɵproperty("resizeEdges", i0.ɵɵpureFunction0(1, _c28));
  }
}
function CalendarWeekViewComponent_div_7_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34, 3);
    i0.ɵɵlistener("resizeStart", function CalendarWeekViewComponent_div_7_div_3_Template_div_resizeStart_0_listener($event) {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      const dayColumns_r16 = i0.ɵɵreference(6);
      return i0.ɵɵresetView(ctx_r2.timeEventResizeStarted(dayColumns_r16, timeEvent_r15, $event));
    })("resizing", function CalendarWeekViewComponent_div_7_div_3_Template_div_resizing_0_listener($event) {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeEventResizing(timeEvent_r15, $event));
    })("resizeEnd", function CalendarWeekViewComponent_div_7_div_3_Template_div_resizeEnd_0_listener() {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeEventResizeEnded(timeEvent_r15));
    })("dragStart", function CalendarWeekViewComponent_div_7_div_3_Template_div_dragStart_0_listener() {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const event_r17 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      const dayColumns_r16 = i0.ɵɵreference(6);
      return i0.ɵɵresetView(ctx_r2.dragStarted(dayColumns_r16, event_r17, timeEvent_r15, true));
    })("dragging", function CalendarWeekViewComponent_div_7_div_3_Template_div_dragging_0_listener($event) {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dragMove(timeEvent_r15, $event));
    })("dragEnd", function CalendarWeekViewComponent_div_7_div_3_Template_div_dragEnd_0_listener($event) {
      const timeEvent_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.dragEnded(timeEvent_r15, $event, ctx_r2.dayColumnWidth, true));
    });
    i0.ɵɵtemplate(2, CalendarWeekViewComponent_div_7_div_3_div_2_Template, 1, 2, "div", 21)(3, CalendarWeekViewComponent_div_7_div_3_ng_template_3_Template, 0, 0, "ng-template", 35)(4, CalendarWeekViewComponent_div_7_div_3_ng_template_4_Template, 1, 12, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(6, CalendarWeekViewComponent_div_7_div_3_div_6_Template, 1, 2, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timeEvent_r15 = ctx.$implicit;
    const weekEventTemplate_r20 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("top", timeEvent_r15.top, "px")("height", timeEvent_r15.height, "px")("left", timeEvent_r15.left, "%")("width", timeEvent_r15.width, "%");
    i0.ɵɵclassProp("cal-draggable", timeEvent_r15.event.draggable && ctx_r2.timeEventResizes.size === 0)("cal-starts-within-day", !timeEvent_r15.startsBeforeDay)("cal-ends-within-day", !timeEvent_r15.endsAfterDay);
    i0.ɵɵproperty("ngClass", timeEvent_r15.event.cssClass)("hidden", timeEvent_r15.height === 0 && timeEvent_r15.width === 0)("resizeCursors", ctx_r2.resizeCursors)("resizeSnapGrid", i0.ɵɵpureFunction4(30, _c26, ctx_r2.dayColumnWidth, ctx_r2.dayColumnWidth, ctx_r2.eventSnapSize || ctx_r2.hourSegmentHeight, ctx_r2.eventSnapSize || ctx_r2.hourSegmentHeight))("validateResize", ctx_r2.validateResize)("allowNegativeResizes", true)("dropData", i0.ɵɵpureFunction2(35, _c22, timeEvent_r15.event, ctx_r2.calendarId))("dragAxis", i0.ɵɵpureFunction2(38, _c9, timeEvent_r15.event.draggable && ctx_r2.timeEventResizes.size === 0, timeEvent_r15.event.draggable && ctx_r2.timeEventResizes.size === 0))("dragSnapGrid", ctx_r2.snapDraggedEvents ? i0.ɵɵpureFunction2(41, _c9, ctx_r2.dayColumnWidth, ctx_r2.eventSnapSize || ctx_r2.hourSegmentHeight) : i0.ɵɵpureFunction0(44, _c3))("touchStartLongPress", i0.ɵɵpureFunction0(45, _c10))("ghostDragEnabled", !ctx_r2.snapDraggedEvents)("ghostElementTemplate", weekEventTemplate_r20)("validateDrag", ctx_r2.validateDrag);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (timeEvent_r15.event == null ? null : timeEvent_r15.event.resizable == null ? null : timeEvent_r15.event.resizable.beforeStart) && !timeEvent_r15.startsBeforeDay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", weekEventTemplate_r20);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (timeEvent_r15.event == null ? null : timeEvent_r15.event.resizable == null ? null : timeEvent_r15.event.resizable.afterEnd) && !timeEvent_r15.endsAfterDay);
  }
}
function CalendarWeekViewComponent_div_7_div_4_mwl_calendar_week_view_hour_segment_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-week-view-hour-segment", 38);
    i0.ɵɵlistener("mwlClick", function CalendarWeekViewComponent_div_7_div_4_mwl_calendar_week_view_hour_segment_1_Template_mwl_calendar_week_view_hour_segment_mwlClick_0_listener($event) {
      const segment_r22 = i0.ɵɵrestoreView(_r21).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.hourSegmentClicked.emit({
        date: segment_r22.date,
        sourceEvent: $event
      }));
    })("drop", function CalendarWeekViewComponent_div_7_div_4_mwl_calendar_week_view_hour_segment_1_Template_mwl_calendar_week_view_hour_segment_drop_0_listener($event) {
      const segment_r22 = i0.ɵɵrestoreView(_r21).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.eventDropped($event, segment_r22.date, false));
    })("dragEnter", function CalendarWeekViewComponent_div_7_div_4_mwl_calendar_week_view_hour_segment_1_Template_mwl_calendar_week_view_hour_segment_dragEnter_0_listener() {
      const segment_r22 = i0.ɵɵrestoreView(_r21).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dateDragEnter(segment_r22.date));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const segment_r22 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("height", ctx_r2.hourSegmentHeight, "px");
    i0.ɵɵproperty("segment", segment_r22)("segmentHeight", ctx_r2.hourSegmentHeight)("locale", ctx_r2.locale)("customTemplate", ctx_r2.hourSegmentTemplate)("daysInWeek", ctx_r2.daysInWeek)("clickListenerDisabled", ctx_r2.hourSegmentClicked.observers.length === 0)("dragOverClass", !ctx_r2.dragActive || !ctx_r2.snapDraggedEvents ? "cal-drag-over" : null)("isTimeLabel", ctx_r2.daysInWeek === 1);
  }
}
function CalendarWeekViewComponent_div_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, CalendarWeekViewComponent_div_7_div_4_mwl_calendar_week_view_hour_segment_1_Template, 1, 10, "mwl-calendar-week-view-hour-segment", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r23 = ctx.$implicit;
    const odd_r24 = ctx.odd;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("cal-hour-odd", odd_r24);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", hour_r23.segments)("ngForTrackBy", ctx_r2.trackByHourSegment);
  }
}
function CalendarWeekViewComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "mwl-calendar-week-view-current-time-marker", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵtemplate(3, CalendarWeekViewComponent_div_7_div_3_Template, 7, 46, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CalendarWeekViewComponent_div_7_div_4_Template, 2, 4, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r19 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("columnDate", column_r19.date)("dayStartHour", ctx_r2.dayStartHour)("dayStartMinute", ctx_r2.dayStartMinute)("dayEndHour", ctx_r2.dayEndHour)("dayEndMinute", ctx_r2.dayEndMinute)("hourSegments", ctx_r2.hourSegments)("hourDuration", ctx_r2.hourDuration)("hourSegmentHeight", ctx_r2.hourSegmentHeight)("customTemplate", ctx_r2.currentTimeMarkerTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", column_r19.events)("ngForTrackBy", ctx_r2.trackByWeekTimeEvent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", column_r19.hours)("ngForTrackBy", ctx_r2.trackByHour);
  }
}
export { DAYS_OF_WEEK } from 'calendar-utils';
import * as i2 from 'angular-draggable-droppable';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i4 from 'angular-resizable-element';
import { ResizableModule } from 'angular-resizable-element';
let ClickDirective = /*#__PURE__*/(() => {
  class ClickDirective {
    constructor(renderer, elm, document) {
      this.renderer = renderer;
      this.elm = elm;
      this.document = document;
      this.clickListenerDisabled = false;
      this.click = new EventEmitter(); // eslint-disable-line
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      if (!this.clickListenerDisabled) {
        this.listen().pipe(takeUntil(this.destroy$)).subscribe(event => {
          event.stopPropagation();
          this.click.emit(event);
        });
      }
    }
    ngOnDestroy() {
      this.destroy$.next();
    }
    listen() {
      return new Observable(observer => {
        return this.renderer.listen(this.elm.nativeElement, 'click', event => {
          observer.next(event);
        });
      });
    }
  }
  ClickDirective.ɵfac = function ClickDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ClickDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DOCUMENT));
  };
  ClickDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ClickDirective,
    selectors: [["", "mwlClick", ""]],
    inputs: {
      clickListenerDisabled: "clickListenerDisabled"
    },
    outputs: {
      click: "mwlClick"
    },
    standalone: false
  });
  return ClickDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KeydownEnterDirective = /*#__PURE__*/(() => {
  class KeydownEnterDirective {
    constructor(host, ngZone, renderer) {
      this.host = host;
      this.ngZone = ngZone;
      this.renderer = renderer;
      this.keydown = new EventEmitter(); // eslint-disable-line
      this.keydownListener = null;
    }
    ngOnInit() {
      this.ngZone.runOutsideAngular(() => {
        this.keydownListener = this.renderer.listen(this.host.nativeElement, 'keydown', event => {
          if (event.keyCode === 13 || event.which === 13 || event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.ngZone.run(() => {
              this.keydown.emit(event);
            });
          }
        });
      });
    }
    ngOnDestroy() {
      if (this.keydownListener !== null) {
        this.keydownListener();
        this.keydownListener = null;
      }
    }
  }
  KeydownEnterDirective.ɵfac = function KeydownEnterDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || KeydownEnterDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  KeydownEnterDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: KeydownEnterDirective,
    selectors: [["", "mwlKeydownEnter", ""]],
    outputs: {
      keydown: "mwlKeydownEnter"
    },
    standalone: false
  });
  return KeydownEnterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class is responsible for adding accessibility to the calendar.
 * You may override any of its methods via angulars DI to suit your requirements.
 * For example:
 *
 * ```typescript
 * import { A11yParams, CalendarA11y } from 'angular-calendar';
 * import { formatDate, I18nPluralPipe } from '@angular/common';
 * import { Injectable } from '@angular/core';
 *
 * // adding your own a11y params
 * export interface CustomA11yParams extends A11yParams {
 *   isDrSuess?: boolean;
 * }
 *
 * @Injectable()
 * export class CustomCalendarA11y extends CalendarA11y {
 *   constructor(protected i18nPlural: I18nPluralPipe) {
 *     super(i18nPlural);
 *   }
 *
 *   // overriding a function
 *   public openDayEventsLandmark({ date, locale, isDrSuess }: CustomA11yParams): string {
 *     if (isDrSuess) {
 *       return `
 *         ${formatDate(date, 'EEEE MMMM d', locale)}
 *          Today you are you! That is truer than true! There is no one alive
 *          who is you-er than you!
 *       `;
 *     }
 *   }
 * }
 *
 * // in your component that uses the calendar
 * providers: [{
 *  provide: CalendarA11y,
 *  useClass: CustomCalendarA11y
 * }]
 * ```
 */
let CalendarA11y = /*#__PURE__*/(() => {
  class CalendarA11y {
    constructor(i18nPlural) {
      this.i18nPlural = i18nPlural;
    }
    /**
     * Aria label for the badges/date of a cell
     * @example: `Saturday October 19 1 event click to expand`
     */
    monthCell({
      day,
      locale
    }) {
      if (day.badgeTotal > 0) {
        return `
        ${formatDate(day.date, 'EEEE MMMM d', locale)},
        ${this.i18nPlural.transform(day.badgeTotal, {
          '=0': 'No events',
          '=1': 'One event',
          other: '# events'
        })},
         click to expand
      `;
      } else {
        return `${formatDate(day.date, 'EEEE MMMM d', locale)}`;
      }
    }
    /**
     * Aria label for the open day events start landmark
     * @example: `Saturday October 19 expanded view`
     */
    openDayEventsLandmark({
      date,
      locale
    }) {
      return `
      Beginning of expanded view for ${formatDate(date, 'EEEE MMMM dd', locale)}
    `;
    }
    /**
     * Aria label for alert that a day in the month view was expanded
     * @example: `Saturday October 19 expanded`
     */
    openDayEventsAlert({
      date,
      locale
    }) {
      return `${formatDate(date, 'EEEE MMMM dd', locale)} expanded`;
    }
    /**
     * Descriptive aria label for an event
     * @example: `Saturday October 19th, Scott's Pizza Party, from 11:00am to 5:00pm`
     */
    eventDescription({
      event,
      locale
    }) {
      if (event.allDay === true) {
        return this.allDayEventDescription({
          event,
          locale
        });
      }
      const aria = `
      ${formatDate(event.start, 'EEEE MMMM dd', locale)},
      ${event.title}, from ${formatDate(event.start, 'hh:mm a', locale)}
    `;
      if (event.end) {
        return aria + ` to ${formatDate(event.end, 'hh:mm a', locale)}`;
      }
      return aria;
    }
    /**
     * Descriptive aria label for an all day event
     * @example:
     * `Scott's Party, event spans multiple days: start time October 19 5:00pm, no stop time`
     */
    allDayEventDescription({
      event,
      locale
    }) {
      const aria = `
      ${event.title}, event spans multiple days:
      start time ${formatDate(event.start, 'MMMM dd hh:mm a', locale)}
    `;
      if (event.end) {
        return aria + `, stop time ${formatDate(event.end, 'MMMM d hh:mm a', locale)}`;
      }
      return aria + `, no stop time`;
    }
    /**
     * Aria label for the calendar event actions icons
     * @returns 'Edit' for fa-pencil icons, and 'Delete' for fa-times icons
     */
    actionButtonLabel({
      action
    }) {
      return action.a11yLabel;
    }
    /**
     * @returns {number} Tab index to be given to month cells
     */
    monthCellTabIndex() {
      return 0;
    }
    /**
     * @returns true if the events inside the month cell should be aria-hidden
     */
    hideMonthCellEvents() {
      return true;
    }
    /**
     * @returns true if event titles should be aria-hidden (global)
     */
    hideEventTitle() {
      return true;
    }
    /**
     * @returns true if hour segments in the week view should be aria-hidden
     */
    hideWeekHourSegment() {
      return true;
    }
    /**
     * @returns true if hour segments in the day view should be aria-hidden
     */
    hideDayHourSegment() {
      return true;
    }
  }
  CalendarA11y.ɵfac = function CalendarA11y_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarA11y)(i0.ɵɵinject(i1.I18nPluralPipe));
  };
  CalendarA11y.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarA11y,
    factory: CalendarA11y.ɵfac
  });
  return CalendarA11y;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This pipe is primarily for rendering aria labels. Example usage:
 * ```typescript
 * // where `myEvent` is a `CalendarEvent` and myLocale is a locale identifier
 * {{ { event: myEvent, locale: myLocale } | calendarA11y: 'eventDescription' }}
 * ```
 */
let CalendarA11yPipe = /*#__PURE__*/(() => {
  class CalendarA11yPipe {
    constructor(calendarA11y, locale) {
      this.calendarA11y = calendarA11y;
      this.locale = locale;
    }
    transform(a11yParams, method) {
      a11yParams.locale = a11yParams.locale || this.locale;
      if (typeof this.calendarA11y[method] === 'undefined') {
        const allowedMethods = Object.getOwnPropertyNames(Object.getPrototypeOf(CalendarA11y.prototype)).filter(iMethod => iMethod !== 'constructor');
        throw new Error(`${method} is not a valid a11y method. Can only be one of ${allowedMethods.join(', ')}`);
      }
      return this.calendarA11y[method](a11yParams);
    }
  }
  CalendarA11yPipe.ɵfac = function CalendarA11yPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarA11yPipe)(i0.ɵɵdirectiveInject(CalendarA11y, 16), i0.ɵɵdirectiveInject(LOCALE_ID, 16));
  };
  CalendarA11yPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "calendarA11y",
    type: CalendarA11yPipe,
    pure: true,
    standalone: false
  });
  return CalendarA11yPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarEventActionsComponent = /*#__PURE__*/(() => {
  class CalendarEventActionsComponent {
    constructor() {
      this.trackByActionId = (index, action) => action.id ? action.id : action;
    }
  }
  CalendarEventActionsComponent.ɵfac = function CalendarEventActionsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarEventActionsComponent)();
  };
  CalendarEventActionsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarEventActionsComponent,
    selectors: [["mwl-calendar-event-actions"]],
    inputs: {
      event: "event",
      customTemplate: "customTemplate"
    },
    standalone: false,
    decls: 3,
    vars: 5,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cal-event-actions", 4, "ngIf"], [1, "cal-event-actions"], ["class", "cal-event-action", "href", "javascript:;", "tabindex", "0", "role", "button", 3, "ngClass", "innerHtml", "mwlClick", "mwlKeydownEnter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["href", "javascript:;", "tabindex", "0", "role", "button", 1, "cal-event-action", 3, "mwlClick", "mwlKeydownEnter", "ngClass", "innerHtml"]],
    template: function CalendarEventActionsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarEventActionsComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarEventActionsComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r6 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0, ctx.event, ctx.trackByActionId));
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, ClickDirective, KeydownEnterDirective, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarEventActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class is responsible for displaying all event titles within the calendar. You may override any of its methods via angulars DI to suit your requirements. For example:
 *
 * ```typescript
 * import { Injectable } from '@angular/core';
 * import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
 *
 * @Injectable()
 * class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
 *
 *   month(event: CalendarEvent): string {
 *     return `Custom prefix: ${event.title}`;
 *   }
 *
 * }
 *
 * // in your component
 * providers: [{
 *  provide: CalendarEventTitleFormatter,
 *  useClass: CustomEventTitleFormatter
 * }]
 * ```
 */
class CalendarEventTitleFormatter {
  /**
   * The month view event title.
   */
  month(event, title) {
    return event.title;
  }
  /**
   * The month view event tooltip. Return a falsey value from this to disable the tooltip.
   */
  monthTooltip(event, title) {
    return event.title;
  }
  /**
   * The week view event title.
   */
  week(event, title) {
    return event.title;
  }
  /**
   * The week view event tooltip. Return a falsey value from this to disable the tooltip.
   */
  weekTooltip(event, title) {
    return event.title;
  }
  /**
   * The day view event title.
   */
  day(event, title) {
    return event.title;
  }
  /**
   * The day view event tooltip. Return a falsey value from this to disable the tooltip.
   */
  dayTooltip(event, title) {
    return event.title;
  }
}
let CalendarEventTitlePipe = /*#__PURE__*/(() => {
  class CalendarEventTitlePipe {
    constructor(calendarEventTitle) {
      this.calendarEventTitle = calendarEventTitle;
    }
    transform(title, titleType, event) {
      return this.calendarEventTitle[titleType](event, title);
    }
  }
  CalendarEventTitlePipe.ɵfac = function CalendarEventTitlePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarEventTitlePipe)(i0.ɵɵdirectiveInject(CalendarEventTitleFormatter, 16));
  };
  CalendarEventTitlePipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "calendarEventTitle",
    type: CalendarEventTitlePipe,
    pure: true,
    standalone: false
  });
  return CalendarEventTitlePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarEventTitleComponent = /*#__PURE__*/(() => {
  class CalendarEventTitleComponent {}
  CalendarEventTitleComponent.ɵfac = function CalendarEventTitleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarEventTitleComponent)();
  };
  CalendarEventTitleComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarEventTitleComponent,
    selectors: [["mwl-calendar-event-title"]],
    inputs: {
      event: "event",
      customTemplate: "customTemplate",
      view: "view"
    },
    standalone: false,
    decls: 3,
    vars: 5,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cal-event-title", 3, "innerHTML"]],
    template: function CalendarEventTitleComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarEventTitleComponent_ng_template_0_Template, 3, 10, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarEventTitleComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r3 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2, ctx.event, ctx.view));
      }
    },
    dependencies: [i1.NgTemplateOutlet, CalendarEventTitlePipe, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarEventTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarTooltipWindowComponent = /*#__PURE__*/(() => {
  class CalendarTooltipWindowComponent {}
  CalendarTooltipWindowComponent.ɵfac = function CalendarTooltipWindowComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarTooltipWindowComponent)();
  };
  CalendarTooltipWindowComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarTooltipWindowComponent,
    selectors: [["mwl-calendar-tooltip-window"]],
    inputs: {
      contents: "contents",
      placement: "placement",
      event: "event",
      customTemplate: "customTemplate"
    },
    standalone: false,
    decls: 3,
    vars: 6,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cal-tooltip", 3, "ngClass"], [1, "cal-tooltip-arrow"], [1, "cal-tooltip-inner", 3, "innerHtml"]],
    template: function CalendarTooltipWindowComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarTooltipWindowComponent_ng_template_0_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarTooltipWindowComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r3 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c4, ctx.contents, ctx.placement, ctx.event));
      }
    },
    dependencies: [i1.NgClass, i1.NgTemplateOutlet],
    encapsulation: 2
  });
  return CalendarTooltipWindowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarTooltipDirective = /*#__PURE__*/(() => {
  class CalendarTooltipDirective {
    constructor(elementRef, injector, renderer, componentFactoryResolver, viewContainerRef, document // eslint-disable-line
    ) {
      this.elementRef = elementRef;
      this.injector = injector;
      this.renderer = renderer;
      this.viewContainerRef = viewContainerRef;
      this.document = document;
      this.placement = 'auto'; // eslint-disable-line  @angular-eslint/no-input-rename
      this.delay = null; // eslint-disable-line  @angular-eslint/no-input-rename
      this.cancelTooltipDelay$ = new Subject();
      this.tooltipFactory = componentFactoryResolver.resolveComponentFactory(CalendarTooltipWindowComponent);
    }
    ngOnChanges(changes) {
      if (this.tooltipRef && (changes.contents || changes.customTemplate || changes.event)) {
        this.tooltipRef.instance.contents = this.contents;
        this.tooltipRef.instance.customTemplate = this.customTemplate;
        this.tooltipRef.instance.event = this.event;
        this.tooltipRef.changeDetectorRef.markForCheck();
        if (!this.contents) {
          this.hide();
        }
      }
    }
    ngOnDestroy() {
      this.hide();
    }
    onMouseOver() {
      const delay$ = this.delay === null ? of('now') : timer(this.delay);
      delay$.pipe(takeUntil(this.cancelTooltipDelay$)).subscribe(() => {
        this.show();
      });
    }
    onMouseOut() {
      this.hide();
    }
    show() {
      if (!this.tooltipRef && this.contents) {
        this.tooltipRef = this.viewContainerRef.createComponent(this.tooltipFactory, 0, this.injector, []);
        this.tooltipRef.instance.contents = this.contents;
        this.tooltipRef.instance.customTemplate = this.customTemplate;
        this.tooltipRef.instance.event = this.event;
        if (this.appendToBody) {
          this.document.body.appendChild(this.tooltipRef.location.nativeElement);
        }
        requestAnimationFrame(() => {
          this.positionTooltip();
        });
      }
    }
    hide() {
      if (this.tooltipRef) {
        this.viewContainerRef.remove(this.viewContainerRef.indexOf(this.tooltipRef.hostView));
        this.tooltipRef = null;
      }
      this.cancelTooltipDelay$.next();
    }
    positionTooltip(previousPositions = []) {
      if (this.tooltipRef) {
        this.tooltipRef.changeDetectorRef.detectChanges();
        this.tooltipRef.instance.placement = positionElements(this.elementRef.nativeElement, this.tooltipRef.location.nativeElement.children[0], this.placement, this.appendToBody);
        // keep re-positioning the tooltip until the arrow position doesn't make a difference
        if (previousPositions.indexOf(this.tooltipRef.instance.placement) === -1) {
          this.positionTooltip([...previousPositions, this.tooltipRef.instance.placement]);
        }
      }
    }
  }
  CalendarTooltipDirective.ɵfac = function CalendarTooltipDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarTooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(DOCUMENT));
  };
  CalendarTooltipDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarTooltipDirective,
    selectors: [["", "mwlCalendarTooltip", ""]],
    hostBindings: function CalendarTooltipDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function CalendarTooltipDirective_mouseenter_HostBindingHandler() {
          return ctx.onMouseOver();
        })("mouseleave", function CalendarTooltipDirective_mouseleave_HostBindingHandler() {
          return ctx.onMouseOut();
        });
      }
    },
    inputs: {
      contents: [0, "mwlCalendarTooltip", "contents"],
      placement: [0, "tooltipPlacement", "placement"],
      customTemplate: [0, "tooltipTemplate", "customTemplate"],
      event: [0, "tooltipEvent", "event"],
      appendToBody: [0, "tooltipAppendToBody", "appendToBody"],
      delay: [0, "tooltipDelay", "delay"]
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature]
  });
  return CalendarTooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CalendarView = /*#__PURE__*/function (CalendarView) {
  CalendarView["Month"] = "month";
  CalendarView["Week"] = "week";
  CalendarView["Day"] = "day";
  return CalendarView;
}(CalendarView || {});
const validateEvents = events => {
  const warn = (...args) => console.warn('angular-calendar', ...args);
  return validateEvents$1(events, warn);
};
function isInsideLeftAndRight(outer, inner) {
  return Math.floor(outer.left) <= Math.ceil(inner.left) && Math.floor(inner.left) <= Math.ceil(outer.right) && Math.floor(outer.left) <= Math.ceil(inner.right) && Math.floor(inner.right) <= Math.ceil(outer.right);
}
function isInsideTopAndBottom(outer, inner) {
  return Math.floor(outer.top) <= Math.ceil(inner.top) && Math.floor(inner.top) <= Math.ceil(outer.bottom) && Math.floor(outer.top) <= Math.ceil(inner.bottom) && Math.floor(inner.bottom) <= Math.ceil(outer.bottom);
}
function isInside(outer, inner) {
  return isInsideLeftAndRight(outer, inner) && isInsideTopAndBottom(outer, inner);
}
function roundToNearest(amount, precision) {
  return Math.round(amount / precision) * precision;
}
const trackByEventId = (index, event) => event.id ? event.id : event;
const trackByWeekDayHeaderDate = (index, day) => day.date.toISOString();
const trackByHourSegment = (index, segment) => segment.date.toISOString();
const trackByHour = (index, hour) => hour.segments[0].date.toISOString();
const trackByWeekAllDayEvent = (index, weekEvent) => weekEvent.event.id ? weekEvent.event.id : weekEvent.event;
const trackByWeekTimeEvent = (index, weekEvent) => weekEvent.event.id ? weekEvent.event.id : weekEvent.event;
const MINUTES_IN_HOUR = 60;
function getPixelAmountInMinutes(hourSegments, hourSegmentHeight, hourDuration) {
  return (hourDuration || MINUTES_IN_HOUR) / (hourSegments * hourSegmentHeight);
}
function getMinutesMoved(movedY, hourSegments, hourSegmentHeight, eventSnapSize, hourDuration) {
  const draggedInPixelsSnapSize = roundToNearest(movedY, eventSnapSize || hourSegmentHeight);
  const pixelAmountInMinutes = getPixelAmountInMinutes(hourSegments, hourSegmentHeight, hourDuration);
  return draggedInPixelsSnapSize * pixelAmountInMinutes;
}
function getDefaultEventEnd(dateAdapter, event, minimumMinutes) {
  if (event.end) {
    return event.end;
  } else {
    return dateAdapter.addMinutes(event.start, minimumMinutes);
  }
}
function addDaysWithExclusions(dateAdapter, date, days, excluded) {
  let daysCounter = 0;
  let daysToAdd = 0;
  const changeDays = days < 0 ? dateAdapter.subDays : dateAdapter.addDays;
  let result = date;
  while (daysToAdd <= Math.abs(days)) {
    result = changeDays(date, daysCounter);
    const day = dateAdapter.getDay(result);
    if (excluded.indexOf(day) === -1) {
      daysToAdd++;
    }
    daysCounter++;
  }
  return result;
}
function isDraggedWithinPeriod(newStart, newEnd, period) {
  const end = newEnd || newStart;
  return period.start <= newStart && newStart <= period.end || period.start <= end && end <= period.end;
}
function shouldFireDroppedEvent(dropEvent, date, allDay, calendarId) {
  return dropEvent.dropData && dropEvent.dropData.event && (dropEvent.dropData.calendarId !== calendarId || dropEvent.dropData.event.allDay && !allDay || !dropEvent.dropData.event.allDay && allDay);
}
function getWeekViewPeriod(dateAdapter, viewDate, weekStartsOn, excluded = [], daysInWeek) {
  let viewStart = daysInWeek ? dateAdapter.startOfDay(viewDate) : dateAdapter.startOfWeek(viewDate, {
    weekStartsOn
  });
  const endOfWeek = dateAdapter.endOfWeek(viewDate, {
    weekStartsOn
  });
  while (excluded.indexOf(dateAdapter.getDay(viewStart)) > -1 && viewStart < endOfWeek) {
    viewStart = dateAdapter.addDays(viewStart, 1);
  }
  if (daysInWeek) {
    const viewEnd = dateAdapter.endOfDay(addDaysWithExclusions(dateAdapter, viewStart, daysInWeek - 1, excluded));
    return {
      viewStart,
      viewEnd
    };
  } else {
    let viewEnd = endOfWeek;
    while (excluded.indexOf(dateAdapter.getDay(viewEnd)) > -1 && viewEnd > viewStart) {
      viewEnd = dateAdapter.subDays(viewEnd, 1);
    }
    return {
      viewStart,
      viewEnd
    };
  }
}
function isWithinThreshold({
  x,
  y
}) {
  const DRAG_THRESHOLD = 1;
  return Math.abs(x) > DRAG_THRESHOLD || Math.abs(y) > DRAG_THRESHOLD;
}
class DateAdapter {}

/**
 * Change the view date to the previous view. For example:
 *
 * ```typescript
 * <button
 *  mwlCalendarPreviousView
 *  [(viewDate)]="viewDate"
 *  [view]="view">
 *  Previous
 * </button>
 * ```
 */
let CalendarPreviousViewDirective = /*#__PURE__*/(() => {
  class CalendarPreviousViewDirective {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
      /**
       * Days to skip when going back by 1 day
       */
      this.excludeDays = [];
      /**
       * Called when the view date is changed
       */
      this.viewDateChange = new EventEmitter();
    }
    /**
     * @hidden
     */
    onClick() {
      const subFn = {
        day: this.dateAdapter.subDays,
        week: this.dateAdapter.subWeeks,
        month: this.dateAdapter.subMonths
      }[this.view];
      if (this.view === CalendarView.Day) {
        this.viewDateChange.emit(addDaysWithExclusions(this.dateAdapter, this.viewDate, -1, this.excludeDays));
      } else if (this.view === CalendarView.Week && this.daysInWeek) {
        this.viewDateChange.emit(addDaysWithExclusions(this.dateAdapter, this.viewDate, -this.daysInWeek, this.excludeDays));
      } else {
        this.viewDateChange.emit(subFn(this.viewDate, 1));
      }
    }
  }
  CalendarPreviousViewDirective.ɵfac = function CalendarPreviousViewDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarPreviousViewDirective)(i0.ɵɵdirectiveInject(DateAdapter));
  };
  CalendarPreviousViewDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarPreviousViewDirective,
    selectors: [["", "mwlCalendarPreviousView", ""]],
    hostBindings: function CalendarPreviousViewDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function CalendarPreviousViewDirective_click_HostBindingHandler() {
          return ctx.onClick();
        });
      }
    },
    inputs: {
      view: "view",
      viewDate: "viewDate",
      excludeDays: "excludeDays",
      daysInWeek: "daysInWeek"
    },
    outputs: {
      viewDateChange: "viewDateChange"
    },
    standalone: false
  });
  return CalendarPreviousViewDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Change the view date to the next view. For example:
 *
 * ```typescript
 * <button
 *  mwlCalendarNextView
 *  [(viewDate)]="viewDate"
 *  [view]="view">
 *  Next
 * </button>
 * ```
 */
let CalendarNextViewDirective = /*#__PURE__*/(() => {
  class CalendarNextViewDirective {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
      /**
       * Days to skip when going forward by 1 day
       */
      this.excludeDays = [];
      /**
       * Called when the view date is changed
       */
      this.viewDateChange = new EventEmitter();
    }
    /**
     * @hidden
     */
    onClick() {
      const addFn = {
        day: this.dateAdapter.addDays,
        week: this.dateAdapter.addWeeks,
        month: this.dateAdapter.addMonths
      }[this.view];
      if (this.view === CalendarView.Day) {
        this.viewDateChange.emit(addDaysWithExclusions(this.dateAdapter, this.viewDate, 1, this.excludeDays));
      } else if (this.view === CalendarView.Week && this.daysInWeek) {
        this.viewDateChange.emit(addDaysWithExclusions(this.dateAdapter, this.viewDate, this.daysInWeek, this.excludeDays));
      } else {
        this.viewDateChange.emit(addFn(this.viewDate, 1));
      }
    }
  }
  CalendarNextViewDirective.ɵfac = function CalendarNextViewDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarNextViewDirective)(i0.ɵɵdirectiveInject(DateAdapter));
  };
  CalendarNextViewDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarNextViewDirective,
    selectors: [["", "mwlCalendarNextView", ""]],
    hostBindings: function CalendarNextViewDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function CalendarNextViewDirective_click_HostBindingHandler() {
          return ctx.onClick();
        });
      }
    },
    inputs: {
      view: "view",
      viewDate: "viewDate",
      excludeDays: "excludeDays",
      daysInWeek: "daysInWeek"
    },
    outputs: {
      viewDateChange: "viewDateChange"
    },
    standalone: false
  });
  return CalendarNextViewDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Change the view date to the current day. For example:
 *
 * ```typescript
 * <button
 *  mwlCalendarToday
 *  [(viewDate)]="viewDate">
 *  Today
 * </button>
 * ```
 */
let CalendarTodayDirective = /*#__PURE__*/(() => {
  class CalendarTodayDirective {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
      /**
       * Called when the view date is changed
       */
      this.viewDateChange = new EventEmitter();
    }
    /**
     * @hidden
     */
    onClick() {
      this.viewDateChange.emit(this.dateAdapter.startOfDay(new Date()));
    }
  }
  CalendarTodayDirective.ɵfac = function CalendarTodayDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarTodayDirective)(i0.ɵɵdirectiveInject(DateAdapter));
  };
  CalendarTodayDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarTodayDirective,
    selectors: [["", "mwlCalendarToday", ""]],
    hostBindings: function CalendarTodayDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function CalendarTodayDirective_click_HostBindingHandler() {
          return ctx.onClick();
        });
      }
    },
    inputs: {
      viewDate: "viewDate"
    },
    outputs: {
      viewDateChange: "viewDateChange"
    },
    standalone: false
  });
  return CalendarTodayDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This will use the angular date pipe to do all date formatting. It is the default date formatter used by the calendar.
 */
let CalendarAngularDateFormatter = /*#__PURE__*/(() => {
  class CalendarAngularDateFormatter {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
    }
    /**
     * The month view header week day labels
     */
    monthViewColumnHeader({
      date,
      locale
    }) {
      return formatDate(date, 'EEEE', locale);
    }
    /**
     * The month view cell day number
     */
    monthViewDayNumber({
      date,
      locale
    }) {
      return formatDate(date, 'd', locale);
    }
    /**
     * The month view title
     */
    monthViewTitle({
      date,
      locale
    }) {
      return formatDate(date, 'LLLL y', locale);
    }
    /**
     * The week view header week day labels
     */
    weekViewColumnHeader({
      date,
      locale
    }) {
      return formatDate(date, 'EEEE', locale);
    }
    /**
     * The week view sub header day and month labels
     */
    weekViewColumnSubHeader({
      date,
      locale
    }) {
      return formatDate(date, 'MMM d', locale);
    }
    /**
     * The week view title
     */
    weekViewTitle({
      date,
      locale,
      weekStartsOn,
      excludeDays,
      daysInWeek
    }) {
      const {
        viewStart,
        viewEnd
      } = getWeekViewPeriod(this.dateAdapter, date, weekStartsOn, excludeDays, daysInWeek);
      const format = (dateToFormat, showYear) => formatDate(dateToFormat, 'MMM d' + (showYear ? ', yyyy' : ''), locale);
      return `${format(viewStart, viewStart.getUTCFullYear() !== viewEnd.getUTCFullYear())} - ${format(viewEnd, true)}`;
    }
    /**
     * The time formatting down the left hand side of the week view
     */
    weekViewHour({
      date,
      locale
    }) {
      return formatDate(date, 'h a', locale);
    }
    /**
     * The time formatting down the left hand side of the day view
     */
    dayViewHour({
      date,
      locale
    }) {
      return formatDate(date, 'h a', locale);
    }
    /**
     * The day view title
     */
    dayViewTitle({
      date,
      locale
    }) {
      return formatDate(date, 'EEEE, MMMM d, y', locale);
    }
  }
  CalendarAngularDateFormatter.ɵfac = function CalendarAngularDateFormatter_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarAngularDateFormatter)(i0.ɵɵinject(DateAdapter));
  };
  CalendarAngularDateFormatter.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarAngularDateFormatter,
    factory: CalendarAngularDateFormatter.ɵfac
  });
  return CalendarAngularDateFormatter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This class is responsible for all formatting of dates. There are 3 implementations available, the `CalendarAngularDateFormatter` (default) which uses the angular date pipe to format dates, the `CalendarNativeDateFormatter` which will use the <a href="https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Intl" target="_blank">Intl</a> API to format dates, or there is the `CalendarMomentDateFormatter` which uses <a href="http://momentjs.com/" target="_blank">moment</a>.
 *
 * If you wish, you may override any of the defaults via angulars DI. For example:
 *
 * ```typescript
 * import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
 * import { formatDate } from '@angular/common';
 * import { Injectable } from '@angular/core';
 *
 * @Injectable()
 * class CustomDateFormatter extends CalendarDateFormatter {
 *
 *   public monthViewColumnHeader({date, locale}: DateFormatterParams): string {
 *     return formatDate(date, 'EEE', locale); // use short week days
 *   }
 *
 * }
 *
 * // in your component that uses the calendar
 * providers: [{
 *   provide: CalendarDateFormatter,
 *   useClass: CustomDateFormatter
 * }]
 * ```
 */
let CalendarDateFormatter = /*#__PURE__*/(() => {
  class CalendarDateFormatter extends CalendarAngularDateFormatter {}
  CalendarDateFormatter.ɵfac = /* @__PURE__ */(() => {
    let ɵCalendarDateFormatter_BaseFactory;
    return function CalendarDateFormatter_Factory(__ngFactoryType__) {
      return (ɵCalendarDateFormatter_BaseFactory || (ɵCalendarDateFormatter_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarDateFormatter)))(__ngFactoryType__ || CalendarDateFormatter);
    };
  })();
  CalendarDateFormatter.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarDateFormatter,
    factory: CalendarDateFormatter.ɵfac
  });
  return CalendarDateFormatter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This pipe is primarily for rendering the current view title. Example usage:
 * ```typescript
 * // where `viewDate` is a `Date` and view is `'month' | 'week' | 'day'`
 * {{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
 * ```
 */
let CalendarDatePipe = /*#__PURE__*/(() => {
  class CalendarDatePipe {
    constructor(dateFormatter, locale) {
      this.dateFormatter = dateFormatter;
      this.locale = locale;
    }
    transform(date, method, locale = this.locale, weekStartsOn = 0, excludeDays = [], daysInWeek) {
      if (typeof this.dateFormatter[method] === 'undefined') {
        const allowedMethods = Object.getOwnPropertyNames(Object.getPrototypeOf(CalendarDateFormatter.prototype)).filter(iMethod => iMethod !== 'constructor');
        throw new Error(`${method} is not a valid date formatter. Can only be one of ${allowedMethods.join(', ')}`);
      }
      return this.dateFormatter[method]({
        date,
        locale,
        weekStartsOn,
        excludeDays,
        daysInWeek
      });
    }
  }
  CalendarDatePipe.ɵfac = function CalendarDatePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarDatePipe)(i0.ɵɵdirectiveInject(CalendarDateFormatter, 16), i0.ɵɵdirectiveInject(LOCALE_ID, 16));
  };
  CalendarDatePipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "calendarDate",
    type: CalendarDatePipe,
    pure: true,
    standalone: false
  });
  return CalendarDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarUtils = /*#__PURE__*/(() => {
  class CalendarUtils {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
    }
    getMonthView(args) {
      return getMonthView(this.dateAdapter, args);
    }
    getWeekViewHeader(args) {
      return getWeekViewHeader(this.dateAdapter, args);
    }
    getWeekView(args) {
      return getWeekView(this.dateAdapter, args);
    }
  }
  CalendarUtils.ɵfac = function CalendarUtils_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarUtils)(i0.ɵɵinject(DateAdapter));
  };
  CalendarUtils.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarUtils,
    factory: CalendarUtils.ɵfac
  });
  return CalendarUtils;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MOMENT = new InjectionToken('Moment');
/**
 * This will use <a href="http://momentjs.com/" target="_blank">moment</a> to do all date formatting. To use this class:
 *
 * ```typescript
 * import { CalendarDateFormatter, CalendarMomentDateFormatter, MOMENT } from 'angular-calendar';
 * import moment from 'moment';
 *
 * // in your component
 * provide: [{
 *   provide: MOMENT, useValue: moment
 * }, {
 *   provide: CalendarDateFormatter, useClass: CalendarMomentDateFormatter
 * }]
 *
 * ```
 */
let CalendarMomentDateFormatter = /*#__PURE__*/(() => {
  class CalendarMomentDateFormatter {
    /**
     * @hidden
     */
    constructor(moment, dateAdapter) {
      this.moment = moment;
      this.dateAdapter = dateAdapter;
    }
    /**
     * The month view header week day labels
     */
    monthViewColumnHeader({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('dddd');
    }
    /**
     * The month view cell day number
     */
    monthViewDayNumber({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('D');
    }
    /**
     * The month view title
     */
    monthViewTitle({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('MMMM YYYY');
    }
    /**
     * The week view header week day labels
     */
    weekViewColumnHeader({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('dddd');
    }
    /**
     * The week view sub header day and month labels
     */
    weekViewColumnSubHeader({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('MMM D');
    }
    /**
     * The week view title
     */
    weekViewTitle({
      date,
      locale,
      weekStartsOn,
      excludeDays,
      daysInWeek
    }) {
      const {
        viewStart,
        viewEnd
      } = getWeekViewPeriod(this.dateAdapter, date, weekStartsOn, excludeDays, daysInWeek);
      const format = (dateToFormat, showYear) => this.moment(dateToFormat).locale(locale).format('MMM D' + (showYear ? ', YYYY' : ''));
      return `${format(viewStart, viewStart.getUTCFullYear() !== viewEnd.getUTCFullYear())} - ${format(viewEnd, true)}`;
    }
    /**
     * The time formatting down the left hand side of the week view
     */
    weekViewHour({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('ha');
    }
    /**
     * The time formatting down the left hand side of the day view
     */
    dayViewHour({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('ha');
    }
    /**
     * The day view title
     */
    dayViewTitle({
      date,
      locale
    }) {
      return this.moment(date).locale(locale).format('dddd, LL'); // dddd = Thursday
    } // LL = locale-dependent Month Day, Year
  }
  CalendarMomentDateFormatter.ɵfac = function CalendarMomentDateFormatter_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarMomentDateFormatter)(i0.ɵɵinject(MOMENT), i0.ɵɵinject(DateAdapter));
  };
  CalendarMomentDateFormatter.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarMomentDateFormatter,
    factory: CalendarMomentDateFormatter.ɵfac
  });
  return CalendarMomentDateFormatter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This will use <a href="https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Intl" target="_blank">Intl</a> API to do all date formatting.
 *
 * You will need to include a <a href="https://github.com/andyearnshaw/Intl.js/">polyfill</a> for older browsers.
 */
let CalendarNativeDateFormatter = /*#__PURE__*/(() => {
  class CalendarNativeDateFormatter {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
    }
    /**
     * The month view header week day labels
     */
    monthViewColumnHeader({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'long'
      }).format(date);
    }
    /**
     * The month view cell day number
     */
    monthViewDayNumber({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        day: 'numeric'
      }).format(date);
    }
    /**
     * The month view title
     */
    monthViewTitle({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long'
      }).format(date);
    }
    /**
     * The week view header week day labels
     */
    weekViewColumnHeader({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'long'
      }).format(date);
    }
    /**
     * The week view sub header day and month labels
     */
    weekViewColumnSubHeader({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short'
      }).format(date);
    }
    /**
     * The week view title
     */
    weekViewTitle({
      date,
      locale,
      weekStartsOn,
      excludeDays,
      daysInWeek
    }) {
      const {
        viewStart,
        viewEnd
      } = getWeekViewPeriod(this.dateAdapter, date, weekStartsOn, excludeDays, daysInWeek);
      const format = (dateToFormat, showYear) => new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        year: showYear ? 'numeric' : undefined
      }).format(dateToFormat);
      return `${format(viewStart, viewStart.getUTCFullYear() !== viewEnd.getUTCFullYear())} - ${format(viewEnd, true)}`;
    }
    /**
     * The time formatting down the left hand side of the week view
     */
    weekViewHour({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        hour: 'numeric'
      }).format(date);
    }
    /**
     * The time formatting down the left hand side of the day view
     */
    dayViewHour({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        hour: 'numeric'
      }).format(date);
    }
    /**
     * The day view title
     */
    dayViewTitle({
      date,
      locale
    }) {
      return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        weekday: 'long'
      }).format(date);
    }
  }
  CalendarNativeDateFormatter.ɵfac = function CalendarNativeDateFormatter_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarNativeDateFormatter)(i0.ɵɵinject(DateAdapter));
  };
  CalendarNativeDateFormatter.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CalendarNativeDateFormatter,
    factory: CalendarNativeDateFormatter.ɵfac
  });
  return CalendarNativeDateFormatter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CalendarEventTimesChangedEventType = /*#__PURE__*/function (CalendarEventTimesChangedEventType) {
  CalendarEventTimesChangedEventType["Drag"] = "drag";
  CalendarEventTimesChangedEventType["Drop"] = "drop";
  CalendarEventTimesChangedEventType["Resize"] = "resize";
  return CalendarEventTimesChangedEventType;
}(CalendarEventTimesChangedEventType || {});
/**
 * Import this module to if you're just using a singular view and want to save on bundle size. Example usage:
 *
 * ```typescript
 * import { CalendarCommonModule, CalendarMonthModule } from 'angular-calendar';
 *
 * @NgModule({
 *   imports: [
 *     CalendarCommonModule.forRoot(),
 *     CalendarMonthModule
 *   ]
 * })
 * class MyModule {}
 * ```
 *
 */
let CalendarCommonModule = /*#__PURE__*/(() => {
  class CalendarCommonModule {
    static forRoot(dateAdapter, config = {}) {
      return {
        ngModule: CalendarCommonModule,
        providers: [dateAdapter, config.eventTitleFormatter || CalendarEventTitleFormatter, config.dateFormatter || CalendarDateFormatter, config.utils || CalendarUtils, config.a11y || CalendarA11y]
      };
    }
  }
  CalendarCommonModule.ɵfac = function CalendarCommonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarCommonModule)();
  };
  CalendarCommonModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalendarCommonModule
  });
  CalendarCommonModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [I18nPluralPipe],
    imports: [CommonModule]
  });
  return CalendarCommonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarMonthCellComponent = /*#__PURE__*/(() => {
  class CalendarMonthCellComponent {
    constructor() {
      this.highlightDay = new EventEmitter();
      this.unhighlightDay = new EventEmitter();
      this.eventClicked = new EventEmitter();
      this.trackByEventId = trackByEventId;
      this.validateDrag = isWithinThreshold;
    }
  }
  CalendarMonthCellComponent.ɵfac = function CalendarMonthCellComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarMonthCellComponent)();
  };
  CalendarMonthCellComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarMonthCellComponent,
    selectors: [["mwl-calendar-month-cell"]],
    hostAttrs: [1, "cal-cell", "cal-day-cell"],
    hostVars: 18,
    hostBindings: function CalendarMonthCellComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("cal-past", ctx.day.isPast)("cal-today", ctx.day.isToday)("cal-future", ctx.day.isFuture)("cal-weekend", ctx.day.isWeekend)("cal-in-month", ctx.day.inMonth)("cal-out-month", !ctx.day.inMonth)("cal-has-events", ctx.day.events.length > 0)("cal-open", ctx.day === ctx.openDay)("cal-event-highlight", !!ctx.day.backgroundColor);
      }
    },
    inputs: {
      day: "day",
      openDay: "openDay",
      locale: "locale",
      tooltipPlacement: "tooltipPlacement",
      tooltipAppendToBody: "tooltipAppendToBody",
      customTemplate: "customTemplate",
      tooltipTemplate: "tooltipTemplate",
      tooltipDelay: "tooltipDelay"
    },
    outputs: {
      highlightDay: "highlightDay",
      unhighlightDay: "unhighlightDay",
      eventClicked: "eventClicked"
    },
    standalone: false,
    decls: 3,
    vars: 15,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cal-cell-top"], ["aria-hidden", "true"], ["class", "cal-day-badge", 4, "ngIf"], [1, "cal-day-number"], ["class", "cal-events", 4, "ngIf"], [1, "cal-day-badge"], [1, "cal-events"], ["class", "cal-event", "mwlDraggable", "", "dragActiveClass", "cal-drag-active", 3, "ngStyle", "ngClass", "mwlCalendarTooltip", "tooltipPlacement", "tooltipEvent", "tooltipTemplate", "tooltipAppendToBody", "tooltipDelay", "cal-draggable", "dropData", "dragAxis", "validateDrag", "touchStartLongPress", "mouseenter", "mouseleave", "mwlClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDraggable", "", "dragActiveClass", "cal-drag-active", 1, "cal-event", 3, "mouseenter", "mouseleave", "mwlClick", "ngStyle", "ngClass", "mwlCalendarTooltip", "tooltipPlacement", "tooltipEvent", "tooltipTemplate", "tooltipAppendToBody", "tooltipDelay", "dropData", "dragAxis", "validateDrag", "touchStartLongPress"]],
    template: function CalendarMonthCellComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarMonthCellComponent_ng_template_0_Template, 8, 14, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarMonthCellComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r15 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r15)("ngTemplateOutletContext", i0.ɵɵpureFunctionV(2, _c5, [ctx.day, ctx.openDay, ctx.locale, ctx.tooltipPlacement, ctx.highlightDay, ctx.unhighlightDay, ctx.eventClicked, ctx.tooltipTemplate, ctx.tooltipAppendToBody, ctx.tooltipDelay, ctx.trackByEventId, ctx.validateDrag]));
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.DraggableDirective, CalendarTooltipDirective, ClickDirective, CalendarDatePipe, CalendarEventTitlePipe, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarMonthCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const collapseAnimation = trigger('collapse', [state('void', style({
  height: 0,
  overflow: 'hidden',
  'padding-top': 0,
  'padding-bottom': 0
})), state('*', style({
  height: '*',
  overflow: 'hidden',
  'padding-top': '*',
  'padding-bottom': '*'
})), transition('* => void', animate('150ms ease-out')), transition('void => *', animate('150ms ease-in'))]);
let CalendarOpenDayEventsComponent = /*#__PURE__*/(() => {
  class CalendarOpenDayEventsComponent {
    constructor() {
      this.isOpen = false;
      this.eventClicked = new EventEmitter();
      this.trackByEventId = trackByEventId;
      this.validateDrag = isWithinThreshold;
    }
  }
  CalendarOpenDayEventsComponent.ɵfac = function CalendarOpenDayEventsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarOpenDayEventsComponent)();
  };
  CalendarOpenDayEventsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarOpenDayEventsComponent,
    selectors: [["mwl-calendar-open-day-events"]],
    inputs: {
      locale: "locale",
      isOpen: "isOpen",
      events: "events",
      customTemplate: "customTemplate",
      eventTitleTemplate: "eventTitleTemplate",
      eventActionsTemplate: "eventActionsTemplate",
      date: "date"
    },
    outputs: {
      eventClicked: "eventClicked"
    },
    standalone: false,
    decls: 3,
    vars: 8,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cal-open-day-events", "role", "application", 4, "ngIf"], ["role", "application", 1, "cal-open-day-events"], ["tabindex", "-1", "role", "alert"], ["tabindex", "0", "role", "landmark"], ["mwlDraggable", "", "dragActiveClass", "cal-drag-active", 3, "ngClass", "cal-draggable", "dropData", "dragAxis", "validateDrag", "touchStartLongPress", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDraggable", "", "dragActiveClass", "cal-drag-active", 3, "ngClass", "dropData", "dragAxis", "validateDrag", "touchStartLongPress"], [1, "cal-event", 3, "ngStyle"], ["view", "month", "tabindex", "0", 3, "mwlClick", "mwlKeydownEnter", "event", "customTemplate"], [3, "event", "customTemplate"]],
    template: function CalendarOpenDayEventsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarOpenDayEventsComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarOpenDayEventsComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r10 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c11, ctx.events, ctx.eventClicked, ctx.isOpen, ctx.trackByEventId, ctx.validateDrag));
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.DraggableDirective, CalendarEventActionsComponent, CalendarEventTitleComponent, ClickDirective, KeydownEnterDirective, CalendarA11yPipe],
    encapsulation: 2,
    data: {
      animation: [collapseAnimation]
    }
  });
  return CalendarOpenDayEventsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarMonthViewHeaderComponent = /*#__PURE__*/(() => {
  class CalendarMonthViewHeaderComponent {
    constructor() {
      this.columnHeaderClicked = new EventEmitter();
      this.trackByWeekDayHeaderDate = trackByWeekDayHeaderDate;
    }
  }
  CalendarMonthViewHeaderComponent.ɵfac = function CalendarMonthViewHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarMonthViewHeaderComponent)();
  };
  CalendarMonthViewHeaderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarMonthViewHeaderComponent,
    selectors: [["mwl-calendar-month-view-header"]],
    inputs: {
      days: "days",
      locale: "locale",
      customTemplate: "customTemplate"
    },
    outputs: {
      columnHeaderClicked: "columnHeaderClicked"
    },
    standalone: false,
    decls: 3,
    vars: 6,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "row", 1, "cal-cell-row", "cal-header"], ["class", "cal-cell", "tabindex", "0", "role", "columnheader", 3, "cal-past", "cal-today", "cal-future", "cal-weekend", "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["tabindex", "0", "role", "columnheader", 1, "cal-cell", 3, "click", "ngClass"]],
    template: function CalendarMonthViewHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarMonthViewHeaderComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarMonthViewHeaderComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r7 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c15, ctx.days, ctx.locale, ctx.trackByWeekDayHeaderDate));
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgTemplateOutlet, CalendarDatePipe],
    encapsulation: 2
  });
  return CalendarMonthViewHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Shows all events on a given month. Example usage:
 *
 * ```typescript
 * <mwl-calendar-month-view
 *  [viewDate]="viewDate"
 *  [events]="events">
 * </mwl-calendar-month-view>
 * ```
 */
let CalendarMonthViewComponent = /*#__PURE__*/(() => {
  class CalendarMonthViewComponent {
    /**
     * @hidden
     */
    constructor(cdr, utils, locale, dateAdapter) {
      this.cdr = cdr;
      this.utils = utils;
      this.dateAdapter = dateAdapter;
      /**
       * An array of events to display on view.
       * The schema is available here: https://github.com/mattlewis92/calendar-utils/blob/c51689985f59a271940e30bc4e2c4e1fee3fcb5c/src/calendarUtils.ts#L49-L63
       */
      this.events = [];
      /**
       * An array of day indexes (0 = sunday, 1 = monday etc) that will be hidden on the view
       */
      this.excludeDays = [];
      /**
       * Whether the events list for the day of the `viewDate` option is visible or not
       */
      this.activeDayIsOpen = false;
      /**
       * The placement of the event tooltip
       */
      this.tooltipPlacement = 'auto';
      /**
       * Whether to append tooltips to the body or next to the trigger element
       */
      this.tooltipAppendToBody = true;
      /**
       * The delay in milliseconds before the tooltip should be displayed. If not provided the tooltip
       * will be displayed immediately.
       */
      this.tooltipDelay = null;
      /**
       * An output that will be called before the view is rendered for the current month.
       * If you add the `cssClass` property to a day in the body it will add that class to the cell element in the template
       */
      this.beforeViewRender = new EventEmitter();
      /**
       * Called when the day cell is clicked
       */
      this.dayClicked = new EventEmitter();
      /**
       * Called when the event title is clicked
       */
      this.eventClicked = new EventEmitter();
      /**
       * Called when a header week day is clicked. Returns ISO day number.
       */
      this.columnHeaderClicked = new EventEmitter();
      /**
       * Called when an event is dragged and dropped
       */
      this.eventTimesChanged = new EventEmitter();
      /**
       * @hidden
       */
      this.trackByRowOffset = (index, offset) => this.view.days.slice(offset, this.view.totalDaysVisibleInWeek).map(day => day.date.toISOString()).join('-');
      /**
       * @hidden
       */
      this.trackByDate = (index, day) => day.date.toISOString();
      this.locale = locale;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      if (this.refresh) {
        this.refreshSubscription = this.refresh.subscribe(() => {
          this.refreshAll();
          this.cdr.markForCheck();
        });
      }
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      const refreshHeader = changes.viewDate || changes.excludeDays || changes.weekendDays;
      const refreshBody = changes.viewDate || changes.events || changes.excludeDays || changes.weekendDays;
      if (refreshHeader) {
        this.refreshHeader();
      }
      if (changes.events) {
        validateEvents(this.events);
      }
      if (refreshBody) {
        this.refreshBody();
      }
      if (refreshHeader || refreshBody) {
        this.emitBeforeViewRender();
      }
      if (changes.activeDayIsOpen || changes.viewDate || changes.events || changes.excludeDays || changes.activeDay) {
        this.checkActiveDayIsOpen();
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
      }
    }
    /**
     * @hidden
     */
    toggleDayHighlight(event, isHighlighted) {
      this.view.days.forEach(day => {
        if (isHighlighted && day.events.indexOf(event) > -1) {
          day.backgroundColor = event.color && event.color.secondary || '#D1E8FF';
        } else {
          delete day.backgroundColor;
        }
      });
    }
    /**
     * @hidden
     */
    eventDropped(droppedOn, event, draggedFrom) {
      if (droppedOn !== draggedFrom) {
        const year = this.dateAdapter.getYear(droppedOn.date);
        const month = this.dateAdapter.getMonth(droppedOn.date);
        const date = this.dateAdapter.getDate(droppedOn.date);
        const newStart = this.dateAdapter.setDate(this.dateAdapter.setMonth(this.dateAdapter.setYear(event.start, year), month), date);
        let newEnd;
        if (event.end) {
          const secondsDiff = this.dateAdapter.differenceInSeconds(newStart, event.start);
          newEnd = this.dateAdapter.addSeconds(event.end, secondsDiff);
        }
        this.eventTimesChanged.emit({
          event,
          newStart,
          newEnd,
          day: droppedOn,
          type: CalendarEventTimesChangedEventType.Drop
        });
      }
    }
    refreshHeader() {
      this.columnHeaders = this.utils.getWeekViewHeader({
        viewDate: this.viewDate,
        weekStartsOn: this.weekStartsOn,
        excluded: this.excludeDays,
        weekendDays: this.weekendDays
      });
    }
    refreshBody() {
      this.view = this.utils.getMonthView({
        events: this.events,
        viewDate: this.viewDate,
        weekStartsOn: this.weekStartsOn,
        excluded: this.excludeDays,
        weekendDays: this.weekendDays
      });
    }
    checkActiveDayIsOpen() {
      if (this.activeDayIsOpen === true) {
        const activeDay = this.activeDay || this.viewDate;
        this.openDay = this.view.days.find(day => this.dateAdapter.isSameDay(day.date, activeDay));
        const index = this.view.days.indexOf(this.openDay);
        this.openRowIndex = Math.floor(index / this.view.totalDaysVisibleInWeek) * this.view.totalDaysVisibleInWeek;
      } else {
        this.openRowIndex = null;
        this.openDay = null;
      }
    }
    refreshAll() {
      this.refreshHeader();
      this.refreshBody();
      this.emitBeforeViewRender();
      this.checkActiveDayIsOpen();
    }
    emitBeforeViewRender() {
      if (this.columnHeaders && this.view) {
        this.beforeViewRender.emit({
          header: this.columnHeaders,
          body: this.view.days,
          period: this.view.period
        });
      }
    }
  }
  CalendarMonthViewComponent.ɵfac = function CalendarMonthViewComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarMonthViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CalendarUtils), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(DateAdapter));
  };
  CalendarMonthViewComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarMonthViewComponent,
    selectors: [["mwl-calendar-month-view"]],
    inputs: {
      viewDate: "viewDate",
      events: "events",
      excludeDays: "excludeDays",
      activeDayIsOpen: "activeDayIsOpen",
      activeDay: "activeDay",
      refresh: "refresh",
      locale: "locale",
      tooltipPlacement: "tooltipPlacement",
      tooltipTemplate: "tooltipTemplate",
      tooltipAppendToBody: "tooltipAppendToBody",
      tooltipDelay: "tooltipDelay",
      weekStartsOn: "weekStartsOn",
      headerTemplate: "headerTemplate",
      cellTemplate: "cellTemplate",
      openDayEventsTemplate: "openDayEventsTemplate",
      eventTitleTemplate: "eventTitleTemplate",
      eventActionsTemplate: "eventActionsTemplate",
      weekendDays: "weekendDays"
    },
    outputs: {
      beforeViewRender: "beforeViewRender",
      dayClicked: "dayClicked",
      eventClicked: "eventClicked",
      columnHeaderClicked: "columnHeaderClicked",
      eventTimesChanged: "eventTimesChanged"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 4,
    vars: 5,
    consts: [["role", "grid", 1, "cal-month-view"], [3, "columnHeaderClicked", "days", "locale", "customTemplate"], [1, "cal-days"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "row", 1, "cal-cell-row"], ["role", "gridcell", "mwlDroppable", "", "dragOverClass", "cal-drag-over", 3, "ngClass", "day", "openDay", "locale", "tooltipPlacement", "tooltipAppendToBody", "tooltipTemplate", "tooltipDelay", "customTemplate", "ngStyle", "clickListenerDisabled", "mwlClick", "mwlKeydownEnter", "highlightDay", "unhighlightDay", "drop", "eventClicked", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDroppable", "", "dragOverClass", "cal-drag-over", 3, "eventClicked", "drop", "locale", "isOpen", "events", "date", "customTemplate", "eventTitleTemplate", "eventActionsTemplate"], ["role", "gridcell", "mwlDroppable", "", "dragOverClass", "cal-drag-over", 3, "mwlClick", "mwlKeydownEnter", "highlightDay", "unhighlightDay", "drop", "eventClicked", "ngClass", "day", "openDay", "locale", "tooltipPlacement", "tooltipAppendToBody", "tooltipTemplate", "tooltipDelay", "customTemplate", "ngStyle", "clickListenerDisabled"]],
    template: function CalendarMonthViewComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "mwl-calendar-month-view-header", 1);
        i0.ɵɵlistener("columnHeaderClicked", function CalendarMonthViewComponent_Template_mwl_calendar_month_view_header_columnHeaderClicked_1_listener($event) {
          return ctx.columnHeaderClicked.emit($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, CalendarMonthViewComponent_div_3_Template, 5, 13, "div", 3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("days", ctx.columnHeaders)("locale", ctx.locale)("customTemplate", ctx.headerTemplate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.view.rowOffsets)("ngForTrackBy", ctx.trackByRowOffset);
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgStyle, i2.DroppableDirective, ClickDirective, KeydownEnterDirective, CalendarMonthCellComponent, CalendarOpenDayEventsComponent, CalendarMonthViewHeaderComponent, i1.SlicePipe, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarMonthViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarMonthModule = /*#__PURE__*/(() => {
  class CalendarMonthModule {}
  CalendarMonthModule.ɵfac = function CalendarMonthModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarMonthModule)();
  };
  CalendarMonthModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalendarMonthModule
  });
  CalendarMonthModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, DragAndDropModule, CalendarCommonModule, DragAndDropModule]
  });
  return CalendarMonthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalendarDragHelper {
  constructor(dragContainerElement, draggableElement) {
    this.dragContainerElement = dragContainerElement;
    this.startPosition = draggableElement.getBoundingClientRect();
  }
  validateDrag({
    x,
    y,
    snapDraggedEvents,
    dragAlreadyMoved,
    transform
  }) {
    const isDraggedWithinThreshold = isWithinThreshold({
      x,
      y
    }) || dragAlreadyMoved;
    if (snapDraggedEvents) {
      const inner = Object.assign({}, this.startPosition, {
        left: this.startPosition.left + transform.x,
        right: this.startPosition.right + transform.x,
        top: this.startPosition.top + transform.y,
        bottom: this.startPosition.bottom + transform.y
      });
      if (isDraggedWithinThreshold) {
        const outer = this.dragContainerElement.getBoundingClientRect();
        const isTopInside = outer.top < inner.top && inner.top < outer.bottom;
        const isBottomInside = outer.top < inner.bottom && inner.bottom < outer.bottom;
        return isInsideLeftAndRight(outer, inner) && (isTopInside || isBottomInside);
      }
      /* istanbul ignore next */
      return false;
    } else {
      return isDraggedWithinThreshold;
    }
  }
}
class CalendarResizeHelper {
  constructor(resizeContainerElement, minWidth, rtl) {
    this.resizeContainerElement = resizeContainerElement;
    this.minWidth = minWidth;
    this.rtl = rtl;
  }
  validateResize({
    rectangle,
    edges
  }) {
    if (this.rtl) {
      // TODO - find a way of testing this, for some reason the tests always fail but it does actually work
      /* istanbul ignore next */
      if (typeof edges.left !== 'undefined') {
        rectangle.left -= edges.left;
        rectangle.right += edges.left;
      } else if (typeof edges.right !== 'undefined') {
        rectangle.left += edges.right;
        rectangle.right -= edges.right;
      }
      rectangle.width = rectangle.right - rectangle.left;
    }
    if (this.minWidth && Math.ceil(rectangle.width) < Math.ceil(this.minWidth)) {
      return false;
    }
    return isInside(this.resizeContainerElement.getBoundingClientRect(), rectangle);
  }
}
let CalendarWeekViewHeaderComponent = /*#__PURE__*/(() => {
  class CalendarWeekViewHeaderComponent {
    constructor() {
      this.dayHeaderClicked = new EventEmitter();
      this.eventDropped = new EventEmitter();
      this.dragEnter = new EventEmitter();
      this.trackByWeekDayHeaderDate = trackByWeekDayHeaderDate;
    }
  }
  CalendarWeekViewHeaderComponent.ɵfac = function CalendarWeekViewHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekViewHeaderComponent)();
  };
  CalendarWeekViewHeaderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarWeekViewHeaderComponent,
    selectors: [["mwl-calendar-week-view-header"]],
    inputs: {
      days: "days",
      locale: "locale",
      customTemplate: "customTemplate"
    },
    outputs: {
      dayHeaderClicked: "dayHeaderClicked",
      eventDropped: "eventDropped",
      dragEnter: "dragEnter"
    },
    standalone: false,
    decls: 3,
    vars: 9,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "row", 1, "cal-day-headers"], ["class", "cal-header", "mwlDroppable", "", "dragOverClass", "cal-drag-over", "tabindex", "0", "role", "columnheader", 3, "cal-past", "cal-today", "cal-future", "cal-weekend", "ngClass", "mwlClick", "drop", "dragEnter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDroppable", "", "dragOverClass", "cal-drag-over", "tabindex", "0", "role", "columnheader", 1, "cal-header", 3, "mwlClick", "drop", "dragEnter", "ngClass"]],
    template: function CalendarWeekViewHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarWeekViewHeaderComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarWeekViewHeaderComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r9 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c16, ctx.days, ctx.locale, ctx.dayHeaderClicked, ctx.eventDropped, ctx.dragEnter, ctx.trackByWeekDayHeaderDate));
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgTemplateOutlet, i2.DroppableDirective, ClickDirective, CalendarDatePipe],
    encapsulation: 2
  });
  return CalendarWeekViewHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarWeekViewEventComponent = /*#__PURE__*/(() => {
  class CalendarWeekViewEventComponent {
    constructor() {
      this.eventClicked = new EventEmitter();
    }
  }
  CalendarWeekViewEventComponent.ɵfac = function CalendarWeekViewEventComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekViewEventComponent)();
  };
  CalendarWeekViewEventComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarWeekViewEventComponent,
    selectors: [["mwl-calendar-week-view-event"]],
    inputs: {
      locale: "locale",
      weekEvent: "weekEvent",
      tooltipPlacement: "tooltipPlacement",
      tooltipAppendToBody: "tooltipAppendToBody",
      tooltipDisabled: "tooltipDisabled",
      tooltipDelay: "tooltipDelay",
      customTemplate: "customTemplate",
      eventTitleTemplate: "eventTitleTemplate",
      eventActionsTemplate: "eventActionsTemplate",
      tooltipTemplate: "tooltipTemplate",
      column: "column",
      daysInWeek: "daysInWeek"
    },
    outputs: {
      eventClicked: "eventClicked"
    },
    standalone: false,
    decls: 3,
    vars: 12,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "0", "role", "application", 1, "cal-event", 3, "mwlClick", "mwlKeydownEnter", "ngStyle", "mwlCalendarTooltip", "tooltipPlacement", "tooltipEvent", "tooltipTemplate", "tooltipAppendToBody", "tooltipDelay"], [3, "event", "customTemplate"], [3, "event", "customTemplate", "view"]],
    template: function CalendarWeekViewEventComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarWeekViewEventComponent_ng_template_0_Template, 6, 27, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarWeekViewEventComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r11 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r11)("ngTemplateOutletContext", i0.ɵɵpureFunctionV(2, _c17, [ctx.weekEvent, ctx.tooltipPlacement, ctx.eventClicked, ctx.tooltipTemplate, ctx.tooltipAppendToBody, ctx.tooltipDisabled, ctx.tooltipDelay, ctx.column, ctx.daysInWeek]));
      }
    },
    dependencies: [i1.NgTemplateOutlet, i1.NgStyle, CalendarEventActionsComponent, CalendarEventTitleComponent, CalendarTooltipDirective, ClickDirective, KeydownEnterDirective, CalendarEventTitlePipe, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarWeekViewEventComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarWeekViewHourSegmentComponent = /*#__PURE__*/(() => {
  class CalendarWeekViewHourSegmentComponent {}
  CalendarWeekViewHourSegmentComponent.ɵfac = function CalendarWeekViewHourSegmentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekViewHourSegmentComponent)();
  };
  CalendarWeekViewHourSegmentComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarWeekViewHourSegmentComponent,
    selectors: [["mwl-calendar-week-view-hour-segment"]],
    inputs: {
      segment: "segment",
      segmentHeight: "segmentHeight",
      locale: "locale",
      isTimeLabel: "isTimeLabel",
      daysInWeek: "daysInWeek",
      customTemplate: "customTemplate"
    },
    standalone: false,
    decls: 3,
    vars: 8,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cal-hour-segment", 3, "ngClass"], ["class", "cal-time", 4, "ngIf"], [1, "cal-time"]],
    template: function CalendarWeekViewHourSegmentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarWeekViewHourSegmentComponent_ng_template_0_Template, 3, 13, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarWeekViewHourSegmentComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
      }
      if (rf & 2) {
        const defaultTemplate_r7 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c19, ctx.segment, ctx.locale, ctx.segmentHeight, ctx.isTimeLabel, ctx.daysInWeek));
      }
    },
    dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, CalendarDatePipe, CalendarA11yPipe],
    encapsulation: 2
  });
  return CalendarWeekViewHourSegmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarWeekViewCurrentTimeMarkerComponent = /*#__PURE__*/(() => {
  class CalendarWeekViewCurrentTimeMarkerComponent {
    constructor(dateAdapter, zone) {
      this.dateAdapter = dateAdapter;
      this.zone = zone;
      this.columnDate$ = new BehaviorSubject(undefined);
      this.marker$ = this.zone.onStable.pipe(switchMap(() => interval(60 * 1000)), startWith(0), switchMapTo(this.columnDate$), map(columnDate => {
        const startOfDay = this.dateAdapter.setMinutes(this.dateAdapter.setHours(columnDate, this.dayStartHour), this.dayStartMinute);
        const endOfDay = this.dateAdapter.setMinutes(this.dateAdapter.setHours(columnDate, this.dayEndHour), this.dayEndMinute);
        const hourHeightModifier = this.hourSegments * this.hourSegmentHeight / (this.hourDuration || 60);
        const now = new Date();
        return {
          isVisible: this.dateAdapter.isSameDay(columnDate, now) && now >= startOfDay && now <= endOfDay,
          top: this.dateAdapter.differenceInMinutes(now, startOfDay) * hourHeightModifier
        };
      }));
    }
    ngOnChanges(changes) {
      if (changes.columnDate) {
        this.columnDate$.next(changes.columnDate.currentValue);
      }
    }
  }
  CalendarWeekViewCurrentTimeMarkerComponent.ɵfac = function CalendarWeekViewCurrentTimeMarkerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekViewCurrentTimeMarkerComponent)(i0.ɵɵdirectiveInject(DateAdapter), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  CalendarWeekViewCurrentTimeMarkerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarWeekViewCurrentTimeMarkerComponent,
    selectors: [["mwl-calendar-week-view-current-time-marker"]],
    inputs: {
      columnDate: "columnDate",
      dayStartHour: "dayStartHour",
      dayStartMinute: "dayStartMinute",
      dayEndHour: "dayEndHour",
      dayEndMinute: "dayEndMinute",
      hourSegments: "hourSegments",
      hourDuration: "hourDuration",
      hourSegmentHeight: "hourSegmentHeight",
      customTemplate: "customTemplate"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 5,
    vars: 14,
    consts: [["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cal-current-time-marker", 3, "top", 4, "ngIf"], [1, "cal-current-time-marker"]],
    template: function CalendarWeekViewCurrentTimeMarkerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CalendarWeekViewCurrentTimeMarkerComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, CalendarWeekViewCurrentTimeMarkerComponent_ng_template_2_Template, 0, 0, "ng-template", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵpipe(4, "async");
      }
      if (rf & 2) {
        let tmp_2_0;
        const defaultTemplate_r3 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.customTemplate || defaultTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction7(6, _c20, ctx.columnDate, ctx.dayStartHour, ctx.dayStartMinute, ctx.dayEndHour, ctx.dayEndMinute, (tmp_2_0 = i0.ɵɵpipeBind1(3, 2, ctx.marker$)) == null ? null : tmp_2_0.isVisible, (tmp_2_0 = i0.ɵɵpipeBind1(4, 4, ctx.marker$)) == null ? null : tmp_2_0.top));
      }
    },
    dependencies: [i1.NgIf, i1.NgTemplateOutlet, i1.AsyncPipe],
    encapsulation: 2
  });
  return CalendarWeekViewCurrentTimeMarkerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Shows all events on a given week. Example usage:
 *
 * ```typescript
 * <mwl-calendar-week-view
 *  [viewDate]="viewDate"
 *  [events]="events">
 * </mwl-calendar-week-view>
 * ```
 */
let CalendarWeekViewComponent = /*#__PURE__*/(() => {
  class CalendarWeekViewComponent {
    /**
     * @hidden
     */
    constructor(cdr, utils, locale, dateAdapter, element) {
      this.cdr = cdr;
      this.utils = utils;
      this.dateAdapter = dateAdapter;
      this.element = element;
      /**
       * An array of events to display on view
       * The schema is available here: https://github.com/mattlewis92/calendar-utils/blob/c51689985f59a271940e30bc4e2c4e1fee3fcb5c/src/calendarUtils.ts#L49-L63
       */
      this.events = [];
      /**
       * An array of day indexes (0 = sunday, 1 = monday etc) that will be hidden on the view
       */
      this.excludeDays = [];
      /**
       * The placement of the event tooltip
       */
      this.tooltipPlacement = 'auto';
      /**
       * Whether to append tooltips to the body or next to the trigger element
       */
      this.tooltipAppendToBody = true;
      /**
       * The delay in milliseconds before the tooltip should be displayed. If not provided the tooltip
       * will be displayed immediately.
       */
      this.tooltipDelay = null;
      /**
       * The precision to display events.
       * `days` will round event start and end dates to the nearest day and `minutes` will not do this rounding
       */
      this.precision = 'days';
      /**
       * Whether to snap events to a grid when dragging
       */
      this.snapDraggedEvents = true;
      /**
       * The number of segments in an hour. Must divide equally into 60.
       */
      this.hourSegments = 2;
      /**
       * The height in pixels of each hour segment
       */
      this.hourSegmentHeight = 30;
      /**
       * The minimum height in pixels of each event
       */
      this.minimumEventHeight = 30;
      /**
       * The day start hours in 24 hour time. Must be 0-23
       */
      this.dayStartHour = 0;
      /**
       * The day start minutes. Must be 0-59
       */
      this.dayStartMinute = 0;
      /**
       * The day end hours in 24 hour time. Must be 0-23
       */
      this.dayEndHour = 23;
      /**
       * The day end minutes. Must be 0-59
       */
      this.dayEndMinute = 59;
      /**
       * Called when a header week day is clicked. Adding a `cssClass` property on `$event.day` will add that class to the header element
       */
      this.dayHeaderClicked = new EventEmitter();
      /**
       * Called when an event title is clicked
       */
      this.eventClicked = new EventEmitter();
      /**
       * Called when an event is resized or dragged and dropped
       */
      this.eventTimesChanged = new EventEmitter();
      /**
       * An output that will be called before the view is rendered for the current week.
       * If you add the `cssClass` property to a day in the header it will add that class to the cell element in the template
       */
      this.beforeViewRender = new EventEmitter();
      /**
       * Called when an hour segment is clicked
       */
      this.hourSegmentClicked = new EventEmitter();
      /**
       * @hidden
       */
      this.allDayEventResizes = new Map();
      /**
       * @hidden
       */
      this.timeEventResizes = new Map();
      /**
       * @hidden
       */
      this.eventDragEnterByType = {
        allDay: 0,
        time: 0
      };
      /**
       * @hidden
       */
      this.dragActive = false;
      /**
       * @hidden
       */
      this.dragAlreadyMoved = false;
      /**
       * @hidden
       */
      this.calendarId = Symbol('angular calendar week view id');
      /**
       * @hidden
       */
      this.rtl = false;
      /**
       * @hidden
       */
      this.trackByWeekDayHeaderDate = trackByWeekDayHeaderDate;
      /**
       * @hidden
       */
      this.trackByHourSegment = trackByHourSegment;
      /**
       * @hidden
       */
      this.trackByHour = trackByHour;
      /**
       * @hidden
       */
      this.trackByWeekAllDayEvent = trackByWeekAllDayEvent;
      /**
       * @hidden
       */
      this.trackByWeekTimeEvent = trackByWeekTimeEvent;
      /**
       * @hidden
       */
      this.trackByHourColumn = (index, column) => column.hours[0] ? column.hours[0].segments[0].date.toISOString() : column;
      /**
       * @hidden
       */
      this.trackById = (index, row) => row.id;
      this.locale = locale;
    }
    /**
     * @hidden
     */
    ngOnInit() {
      if (this.refresh) {
        this.refreshSubscription = this.refresh.subscribe(() => {
          this.refreshAll();
          this.cdr.markForCheck();
        });
      }
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
      const refreshHeader = changes.viewDate || changes.excludeDays || changes.weekendDays || changes.daysInWeek || changes.weekStartsOn;
      const refreshBody = changes.viewDate || changes.dayStartHour || changes.dayStartMinute || changes.dayEndHour || changes.dayEndMinute || changes.hourSegments || changes.hourDuration || changes.weekStartsOn || changes.weekendDays || changes.excludeDays || changes.hourSegmentHeight || changes.events || changes.daysInWeek || changes.minimumEventHeight;
      if (refreshHeader) {
        this.refreshHeader();
      }
      if (changes.events) {
        validateEvents(this.events);
      }
      if (refreshBody) {
        this.refreshBody();
      }
      if (refreshHeader || refreshBody) {
        this.emitBeforeViewRender();
      }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
      if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
      }
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
      this.rtl = typeof window !== 'undefined' && getComputedStyle(this.element.nativeElement).direction === 'rtl';
      this.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    timeEventResizeStarted(eventsContainer, timeEvent, resizeEvent) {
      this.timeEventResizes.set(timeEvent.event, resizeEvent);
      this.resizeStarted(eventsContainer, timeEvent);
    }
    /**
     * @hidden
     */
    timeEventResizing(timeEvent, resizeEvent) {
      this.timeEventResizes.set(timeEvent.event, resizeEvent);
      const adjustedEvents = new Map();
      const tempEvents = [...this.events];
      this.timeEventResizes.forEach((lastResizeEvent, event) => {
        const newEventDates = this.getTimeEventResizedDates(event, lastResizeEvent);
        const adjustedEvent = {
          ...event,
          ...newEventDates
        };
        adjustedEvents.set(adjustedEvent, event);
        const eventIndex = tempEvents.indexOf(event);
        tempEvents[eventIndex] = adjustedEvent;
      });
      this.restoreOriginalEvents(tempEvents, adjustedEvents, true);
    }
    /**
     * @hidden
     */
    timeEventResizeEnded(timeEvent) {
      this.view = this.getWeekView(this.events);
      const lastResizeEvent = this.timeEventResizes.get(timeEvent.event);
      if (lastResizeEvent) {
        this.timeEventResizes.delete(timeEvent.event);
        const newEventDates = this.getTimeEventResizedDates(timeEvent.event, lastResizeEvent);
        this.eventTimesChanged.emit({
          newStart: newEventDates.start,
          newEnd: newEventDates.end,
          event: timeEvent.event,
          type: CalendarEventTimesChangedEventType.Resize
        });
      }
    }
    /**
     * @hidden
     */
    allDayEventResizeStarted(allDayEventsContainer, allDayEvent, resizeEvent) {
      this.allDayEventResizes.set(allDayEvent, {
        originalOffset: allDayEvent.offset,
        originalSpan: allDayEvent.span,
        edge: typeof resizeEvent.edges.left !== 'undefined' ? 'left' : 'right'
      });
      this.resizeStarted(allDayEventsContainer, allDayEvent, this.getDayColumnWidth(allDayEventsContainer));
    }
    /**
     * @hidden
     */
    allDayEventResizing(allDayEvent, resizeEvent, dayWidth) {
      const currentResize = this.allDayEventResizes.get(allDayEvent);
      const modifier = this.rtl ? -1 : 1;
      if (typeof resizeEvent.edges.left !== 'undefined') {
        const diff = Math.round(+resizeEvent.edges.left / dayWidth) * modifier;
        allDayEvent.offset = currentResize.originalOffset + diff;
        allDayEvent.span = currentResize.originalSpan - diff;
      } else if (typeof resizeEvent.edges.right !== 'undefined') {
        const diff = Math.round(+resizeEvent.edges.right / dayWidth) * modifier;
        allDayEvent.span = currentResize.originalSpan + diff;
      }
    }
    /**
     * @hidden
     */
    allDayEventResizeEnded(allDayEvent) {
      const currentResize = this.allDayEventResizes.get(allDayEvent);
      if (currentResize) {
        const allDayEventResizingBeforeStart = currentResize.edge === 'left';
        let daysDiff;
        if (allDayEventResizingBeforeStart) {
          daysDiff = allDayEvent.offset - currentResize.originalOffset;
        } else {
          daysDiff = allDayEvent.span - currentResize.originalSpan;
        }
        allDayEvent.offset = currentResize.originalOffset;
        allDayEvent.span = currentResize.originalSpan;
        const newDates = this.getAllDayEventResizedDates(allDayEvent.event, daysDiff, allDayEventResizingBeforeStart);
        this.eventTimesChanged.emit({
          newStart: newDates.start,
          newEnd: newDates.end,
          event: allDayEvent.event,
          type: CalendarEventTimesChangedEventType.Resize
        });
        this.allDayEventResizes.delete(allDayEvent);
      }
    }
    /**
     * @hidden
     */
    getDayColumnWidth(eventRowContainer) {
      return Math.floor(eventRowContainer.offsetWidth / this.days.length);
    }
    /**
     * @hidden
     */
    dateDragEnter(date) {
      this.lastDragEnterDate = date;
    }
    /**
     * @hidden
     */
    eventDropped(dropEvent, date, allDay) {
      if (shouldFireDroppedEvent(dropEvent, date, allDay, this.calendarId) && this.lastDragEnterDate.getTime() === date.getTime() && (!this.snapDraggedEvents || dropEvent.dropData.event !== this.lastDraggedEvent)) {
        this.eventTimesChanged.emit({
          type: CalendarEventTimesChangedEventType.Drop,
          event: dropEvent.dropData.event,
          newStart: date,
          allDay
        });
      }
      this.lastDraggedEvent = null;
    }
    /**
     * @hidden
     */
    dragEnter(type) {
      this.eventDragEnterByType[type]++;
    }
    /**
     * @hidden
     */
    dragLeave(type) {
      this.eventDragEnterByType[type]--;
    }
    /**
     * @hidden
     */
    dragStarted(eventsContainerElement, eventElement, event, useY) {
      this.dayColumnWidth = this.getDayColumnWidth(eventsContainerElement);
      const dragHelper = new CalendarDragHelper(eventsContainerElement, eventElement);
      this.validateDrag = ({
        x,
        y,
        transform
      }) => {
        const isAllowed = this.allDayEventResizes.size === 0 && this.timeEventResizes.size === 0 && dragHelper.validateDrag({
          x,
          y,
          snapDraggedEvents: this.snapDraggedEvents,
          dragAlreadyMoved: this.dragAlreadyMoved,
          transform
        });
        if (isAllowed && this.validateEventTimesChanged) {
          const newEventTimes = this.getDragMovedEventTimes(event, {
            x,
            y
          }, this.dayColumnWidth, useY);
          return this.validateEventTimesChanged({
            type: CalendarEventTimesChangedEventType.Drag,
            event: event.event,
            newStart: newEventTimes.start,
            newEnd: newEventTimes.end
          });
        }
        return isAllowed;
      };
      this.dragActive = true;
      this.dragAlreadyMoved = false;
      this.lastDraggedEvent = null;
      this.eventDragEnterByType = {
        allDay: 0,
        time: 0
      };
      if (!this.snapDraggedEvents && useY) {
        this.view.hourColumns.forEach(column => {
          const linkedEvent = column.events.find(columnEvent => columnEvent.event === event.event && columnEvent !== event);
          // hide any linked events while dragging
          if (linkedEvent) {
            linkedEvent.width = 0;
            linkedEvent.height = 0;
          }
        });
      }
      this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    dragMove(dayEvent, dragEvent) {
      const newEventTimes = this.getDragMovedEventTimes(dayEvent, dragEvent, this.dayColumnWidth, true);
      const originalEvent = dayEvent.event;
      const adjustedEvent = {
        ...originalEvent,
        ...newEventTimes
      };
      const tempEvents = this.events.map(event => {
        if (event === originalEvent) {
          return adjustedEvent;
        }
        return event;
      });
      this.restoreOriginalEvents(tempEvents, new Map([[adjustedEvent, originalEvent]]), this.snapDraggedEvents);
      this.dragAlreadyMoved = true;
    }
    /**
     * @hidden
     */
    allDayEventDragMove() {
      this.dragAlreadyMoved = true;
    }
    /**
     * @hidden
     */
    dragEnded(weekEvent, dragEndEvent, dayWidth, useY = false) {
      this.view = this.getWeekView(this.events);
      this.dragActive = false;
      this.validateDrag = null;
      const {
        start,
        end
      } = this.getDragMovedEventTimes(weekEvent, dragEndEvent, dayWidth, useY);
      if ((this.snapDraggedEvents || this.eventDragEnterByType[useY ? 'time' : 'allDay'] > 0) && isDraggedWithinPeriod(start, end, this.view.period)) {
        this.lastDraggedEvent = weekEvent.event;
        this.eventTimesChanged.emit({
          newStart: start,
          newEnd: end,
          event: weekEvent.event,
          type: CalendarEventTimesChangedEventType.Drag,
          allDay: !useY
        });
      }
    }
    refreshHeader() {
      this.days = this.utils.getWeekViewHeader({
        viewDate: this.viewDate,
        weekStartsOn: this.weekStartsOn,
        excluded: this.excludeDays,
        weekendDays: this.weekendDays,
        ...getWeekViewPeriod(this.dateAdapter, this.viewDate, this.weekStartsOn, this.excludeDays, this.daysInWeek)
      });
    }
    refreshBody() {
      this.view = this.getWeekView(this.events);
    }
    refreshAll() {
      this.refreshHeader();
      this.refreshBody();
      this.emitBeforeViewRender();
    }
    emitBeforeViewRender() {
      if (this.days && this.view) {
        this.beforeViewRender.emit({
          header: this.days,
          ...this.view
        });
      }
    }
    getWeekView(events) {
      return this.utils.getWeekView({
        events,
        viewDate: this.viewDate,
        weekStartsOn: this.weekStartsOn,
        excluded: this.excludeDays,
        precision: this.precision,
        absolutePositionedEvents: true,
        hourSegments: this.hourSegments,
        hourDuration: this.hourDuration,
        dayStart: {
          hour: this.dayStartHour,
          minute: this.dayStartMinute
        },
        dayEnd: {
          hour: this.dayEndHour,
          minute: this.dayEndMinute
        },
        segmentHeight: this.hourSegmentHeight,
        weekendDays: this.weekendDays,
        minimumEventHeight: this.minimumEventHeight,
        ...getWeekViewPeriod(this.dateAdapter, this.viewDate, this.weekStartsOn, this.excludeDays, this.daysInWeek)
      });
    }
    getDragMovedEventTimes(weekEvent, dragEndEvent, dayWidth, useY) {
      const daysDragged = roundToNearest(dragEndEvent.x, dayWidth) / dayWidth * (this.rtl ? -1 : 1);
      const minutesMoved = useY ? getMinutesMoved(dragEndEvent.y, this.hourSegments, this.hourSegmentHeight, this.eventSnapSize, this.hourDuration) : 0;
      const start = this.dateAdapter.addMinutes(addDaysWithExclusions(this.dateAdapter, weekEvent.event.start, daysDragged, this.excludeDays), minutesMoved);
      let end;
      if (weekEvent.event.end) {
        end = this.dateAdapter.addMinutes(addDaysWithExclusions(this.dateAdapter, weekEvent.event.end, daysDragged, this.excludeDays), minutesMoved);
      }
      return {
        start,
        end
      };
    }
    restoreOriginalEvents(tempEvents, adjustedEvents, snapDraggedEvents = true) {
      const previousView = this.view;
      if (snapDraggedEvents) {
        this.view = this.getWeekView(tempEvents);
      }
      const adjustedEventsArray = tempEvents.filter(event => adjustedEvents.has(event));
      this.view.hourColumns.forEach((column, columnIndex) => {
        previousView.hourColumns[columnIndex].hours.forEach((hour, hourIndex) => {
          hour.segments.forEach((segment, segmentIndex) => {
            column.hours[hourIndex].segments[segmentIndex].cssClass = segment.cssClass;
          });
        });
        adjustedEventsArray.forEach(adjustedEvent => {
          const originalEvent = adjustedEvents.get(adjustedEvent);
          const existingColumnEvent = column.events.find(columnEvent => columnEvent.event === (snapDraggedEvents ? adjustedEvent : originalEvent));
          if (existingColumnEvent) {
            // restore the original event so trackBy kicks in and the dom isn't changed
            existingColumnEvent.event = originalEvent;
            existingColumnEvent['tempEvent'] = adjustedEvent;
            if (!snapDraggedEvents) {
              existingColumnEvent.height = 0;
              existingColumnEvent.width = 0;
            }
          } else {
            // add a dummy event to the drop so if the event was removed from the original column the drag doesn't end early
            const event = {
              event: originalEvent,
              left: 0,
              top: 0,
              height: 0,
              width: 0,
              startsBeforeDay: false,
              endsAfterDay: false,
              tempEvent: adjustedEvent
            };
            column.events.push(event);
          }
        });
      });
      adjustedEvents.clear();
    }
    getTimeEventResizedDates(calendarEvent, resizeEvent) {
      const newEventDates = {
        start: calendarEvent.start,
        end: getDefaultEventEnd(this.dateAdapter, calendarEvent, this.minimumEventHeight)
      };
      const {
        end,
        ...eventWithoutEnd
      } = calendarEvent;
      const smallestResizes = {
        start: this.dateAdapter.addMinutes(newEventDates.end, this.minimumEventHeight * -1),
        end: getDefaultEventEnd(this.dateAdapter, eventWithoutEnd, this.minimumEventHeight)
      };
      const modifier = this.rtl ? -1 : 1;
      if (typeof resizeEvent.edges.left !== 'undefined') {
        const daysDiff = Math.round(+resizeEvent.edges.left / this.dayColumnWidth) * modifier;
        const newStart = addDaysWithExclusions(this.dateAdapter, newEventDates.start, daysDiff, this.excludeDays);
        if (newStart < smallestResizes.start) {
          newEventDates.start = newStart;
        } else {
          newEventDates.start = smallestResizes.start;
        }
      } else if (typeof resizeEvent.edges.right !== 'undefined') {
        const daysDiff = Math.round(+resizeEvent.edges.right / this.dayColumnWidth) * modifier;
        const newEnd = addDaysWithExclusions(this.dateAdapter, newEventDates.end, daysDiff, this.excludeDays);
        if (newEnd > smallestResizes.end) {
          newEventDates.end = newEnd;
        } else {
          newEventDates.end = smallestResizes.end;
        }
      }
      if (typeof resizeEvent.edges.top !== 'undefined') {
        const minutesMoved = getMinutesMoved(resizeEvent.edges.top, this.hourSegments, this.hourSegmentHeight, this.eventSnapSize, this.hourDuration);
        const newStart = this.dateAdapter.addMinutes(newEventDates.start, minutesMoved);
        if (newStart < smallestResizes.start) {
          newEventDates.start = newStart;
        } else {
          newEventDates.start = smallestResizes.start;
        }
      } else if (typeof resizeEvent.edges.bottom !== 'undefined') {
        const minutesMoved = getMinutesMoved(resizeEvent.edges.bottom, this.hourSegments, this.hourSegmentHeight, this.eventSnapSize, this.hourDuration);
        const newEnd = this.dateAdapter.addMinutes(newEventDates.end, minutesMoved);
        if (newEnd > smallestResizes.end) {
          newEventDates.end = newEnd;
        } else {
          newEventDates.end = smallestResizes.end;
        }
      }
      return newEventDates;
    }
    resizeStarted(eventsContainer, event, dayWidth) {
      this.dayColumnWidth = this.getDayColumnWidth(eventsContainer);
      const resizeHelper = new CalendarResizeHelper(eventsContainer, dayWidth, this.rtl);
      this.validateResize = ({
        rectangle,
        edges
      }) => {
        const isWithinBoundary = resizeHelper.validateResize({
          rectangle: {
            ...rectangle
          },
          edges
        });
        if (isWithinBoundary && this.validateEventTimesChanged) {
          let newEventDates;
          if (!dayWidth) {
            newEventDates = this.getTimeEventResizedDates(event.event, {
              rectangle,
              edges
            });
          } else {
            const modifier = this.rtl ? -1 : 1;
            if (typeof edges.left !== 'undefined') {
              const diff = Math.round(+edges.left / dayWidth) * modifier;
              newEventDates = this.getAllDayEventResizedDates(event.event, diff, !this.rtl);
            } else {
              const diff = Math.round(+edges.right / dayWidth) * modifier;
              newEventDates = this.getAllDayEventResizedDates(event.event, diff, this.rtl);
            }
          }
          return this.validateEventTimesChanged({
            type: CalendarEventTimesChangedEventType.Resize,
            event: event.event,
            newStart: newEventDates.start,
            newEnd: newEventDates.end
          });
        }
        return isWithinBoundary;
      };
      this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    getAllDayEventResizedDates(event, daysDiff, beforeStart) {
      let start = event.start;
      let end = event.end || event.start;
      if (beforeStart) {
        start = addDaysWithExclusions(this.dateAdapter, start, daysDiff, this.excludeDays);
      } else {
        end = addDaysWithExclusions(this.dateAdapter, end, daysDiff, this.excludeDays);
      }
      return {
        start,
        end
      };
    }
  }
  CalendarWeekViewComponent.ɵfac = function CalendarWeekViewComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CalendarUtils), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(DateAdapter), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  CalendarWeekViewComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarWeekViewComponent,
    selectors: [["mwl-calendar-week-view"]],
    inputs: {
      viewDate: "viewDate",
      events: "events",
      excludeDays: "excludeDays",
      refresh: "refresh",
      locale: "locale",
      tooltipPlacement: "tooltipPlacement",
      tooltipTemplate: "tooltipTemplate",
      tooltipAppendToBody: "tooltipAppendToBody",
      tooltipDelay: "tooltipDelay",
      weekStartsOn: "weekStartsOn",
      headerTemplate: "headerTemplate",
      eventTemplate: "eventTemplate",
      eventTitleTemplate: "eventTitleTemplate",
      eventActionsTemplate: "eventActionsTemplate",
      precision: "precision",
      weekendDays: "weekendDays",
      snapDraggedEvents: "snapDraggedEvents",
      hourSegments: "hourSegments",
      hourDuration: "hourDuration",
      hourSegmentHeight: "hourSegmentHeight",
      minimumEventHeight: "minimumEventHeight",
      dayStartHour: "dayStartHour",
      dayStartMinute: "dayStartMinute",
      dayEndHour: "dayEndHour",
      dayEndMinute: "dayEndMinute",
      hourSegmentTemplate: "hourSegmentTemplate",
      eventSnapSize: "eventSnapSize",
      allDayEventsLabelTemplate: "allDayEventsLabelTemplate",
      daysInWeek: "daysInWeek",
      currentTimeMarkerTemplate: "currentTimeMarkerTemplate",
      validateEventTimesChanged: "validateEventTimesChanged",
      resizeCursors: "resizeCursors"
    },
    outputs: {
      dayHeaderClicked: "dayHeaderClicked",
      eventClicked: "eventClicked",
      eventTimesChanged: "eventTimesChanged",
      beforeViewRender: "beforeViewRender",
      hourSegmentClicked: "hourSegmentClicked"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 8,
    vars: 9,
    consts: [["dayColumns", ""], ["allDayEventsContainer", ""], ["eventRowContainer", ""], ["event", ""], ["weekEventTemplate", ""], ["role", "grid", 1, "cal-week-view"], [3, "dayHeaderClicked", "eventDropped", "dragEnter", "days", "locale", "customTemplate"], ["class", "cal-all-day-events", "mwlDroppable", "", 3, "dragEnter", "dragLeave", 4, "ngIf"], ["mwlDroppable", "", 1, "cal-time-events", 3, "dragEnter", "dragLeave"], ["class", "cal-time-label-column", 4, "ngIf"], [1, "cal-day-columns"], ["class", "cal-day-column", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDroppable", "", 1, "cal-all-day-events", 3, "dragEnter", "dragLeave"], [1, "cal-time-label-column"], [4, "ngTemplateOutlet"], ["class", "cal-day-column", "mwlDroppable", "", "dragOverClass", "cal-drag-over", 3, "drop", "dragEnter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "cal-events-row", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDroppable", "", "dragOverClass", "cal-drag-over", 1, "cal-day-column", 3, "drop", "dragEnter"], [1, "cal-events-row"], ["class", "cal-event-container", "mwlResizable", "", "mwlDraggable", "", "dragActiveClass", "cal-drag-active", 3, "cal-draggable", "cal-starts-within-week", "cal-ends-within-week", "ngClass", "width", "marginLeft", "marginRight", "resizeCursors", "resizeSnapGrid", "validateResize", "dropData", "dragAxis", "dragSnapGrid", "validateDrag", "touchStartLongPress", "resizeStart", "resizing", "resizeEnd", "dragStart", "dragging", "dragEnd", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlResizable", "", "mwlDraggable", "", "dragActiveClass", "cal-drag-active", 1, "cal-event-container", 3, "resizeStart", "resizing", "resizeEnd", "dragStart", "dragging", "dragEnd", "ngClass", "resizeCursors", "resizeSnapGrid", "validateResize", "dropData", "dragAxis", "dragSnapGrid", "validateDrag", "touchStartLongPress"], ["class", "cal-resize-handle cal-resize-handle-before-start", "mwlResizeHandle", "", 3, "resizeEdges", 4, "ngIf"], [3, "eventClicked", "locale", "weekEvent", "tooltipPlacement", "tooltipTemplate", "tooltipAppendToBody", "tooltipDelay", "customTemplate", "eventTitleTemplate", "eventActionsTemplate", "daysInWeek"], ["class", "cal-resize-handle cal-resize-handle-after-end", "mwlResizeHandle", "", 3, "resizeEdges", 4, "ngIf"], ["mwlResizeHandle", "", 1, "cal-resize-handle", "cal-resize-handle-before-start", 3, "resizeEdges"], ["mwlResizeHandle", "", 1, "cal-resize-handle", "cal-resize-handle-after-end", 3, "resizeEdges"], ["class", "cal-hour", 3, "cal-hour-odd", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "cal-hour"], [3, "height", "segment", "segmentHeight", "locale", "customTemplate", "isTimeLabel", "daysInWeek", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "segment", "segmentHeight", "locale", "customTemplate", "isTimeLabel", "daysInWeek"], [1, "cal-day-column"], [3, "columnDate", "dayStartHour", "dayStartMinute", "dayEndHour", "dayEndMinute", "hourSegments", "hourDuration", "hourSegmentHeight", "customTemplate"], [1, "cal-events-container"], ["class", "cal-event-container", "mwlResizable", "", "mwlDraggable", "", "dragActiveClass", "cal-drag-active", 3, "cal-draggable", "cal-starts-within-day", "cal-ends-within-day", "ngClass", "hidden", "top", "height", "left", "width", "resizeCursors", "resizeSnapGrid", "validateResize", "allowNegativeResizes", "dropData", "dragAxis", "dragSnapGrid", "touchStartLongPress", "ghostDragEnabled", "ghostElementTemplate", "validateDrag", "resizeStart", "resizing", "resizeEnd", "dragStart", "dragging", "dragEnd", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlResizable", "", "mwlDraggable", "", "dragActiveClass", "cal-drag-active", 1, "cal-event-container", 3, "resizeStart", "resizing", "resizeEnd", "dragStart", "dragging", "dragEnd", "ngClass", "hidden", "resizeCursors", "resizeSnapGrid", "validateResize", "allowNegativeResizes", "dropData", "dragAxis", "dragSnapGrid", "touchStartLongPress", "ghostDragEnabled", "ghostElementTemplate", "validateDrag"], [3, "ngTemplateOutlet"], [3, "eventClicked", "locale", "weekEvent", "tooltipPlacement", "tooltipTemplate", "tooltipAppendToBody", "tooltipDisabled", "tooltipDelay", "customTemplate", "eventTitleTemplate", "eventActionsTemplate", "column", "daysInWeek"], ["mwlDroppable", "", "dragActiveClass", "cal-drag-active", 3, "height", "segment", "segmentHeight", "locale", "customTemplate", "daysInWeek", "clickListenerDisabled", "dragOverClass", "isTimeLabel", "mwlClick", "drop", "dragEnter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["mwlDroppable", "", "dragActiveClass", "cal-drag-active", 3, "mwlClick", "drop", "dragEnter", "segment", "segmentHeight", "locale", "customTemplate", "daysInWeek", "clickListenerDisabled", "dragOverClass", "isTimeLabel"]],
    template: function CalendarWeekViewComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 5)(1, "mwl-calendar-week-view-header", 6);
        i0.ɵɵlistener("dayHeaderClicked", function CalendarWeekViewComponent_Template_mwl_calendar_week_view_header_dayHeaderClicked_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.dayHeaderClicked.emit($event));
        })("eventDropped", function CalendarWeekViewComponent_Template_mwl_calendar_week_view_header_eventDropped_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.eventDropped({
            dropData: $event
          }, $event.newStart, true));
        })("dragEnter", function CalendarWeekViewComponent_Template_mwl_calendar_week_view_header_dragEnter_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.dateDragEnter($event.date));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CalendarWeekViewComponent_div_2_Template, 7, 5, "div", 7);
        i0.ɵɵelementStart(3, "div", 8);
        i0.ɵɵlistener("dragEnter", function CalendarWeekViewComponent_Template_div_dragEnter_3_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.dragEnter("time"));
        })("dragLeave", function CalendarWeekViewComponent_Template_div_dragLeave_3_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.dragLeave("time"));
        });
        i0.ɵɵtemplate(4, CalendarWeekViewComponent_div_4_Template, 2, 2, "div", 9);
        i0.ɵɵelementStart(5, "div", 10, 0);
        i0.ɵɵtemplate(7, CalendarWeekViewComponent_div_7_Template, 5, 13, "div", 11);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("days", ctx.days)("locale", ctx.locale)("customTemplate", ctx.headerTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.view.allDayEventRows.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.view.hourColumns.length > 0 && ctx.daysInWeek !== 1);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("cal-resize-active", ctx.timeEventResizes.size > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.view.hourColumns)("ngForTrackBy", ctx.trackByHourColumn);
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i4.ResizableDirective, i4.ResizeHandleDirective, i2.DraggableDirective, i2.DroppableDirective, ClickDirective, CalendarWeekViewHeaderComponent, CalendarWeekViewEventComponent, CalendarWeekViewHourSegmentComponent, CalendarWeekViewCurrentTimeMarkerComponent],
    encapsulation: 2
  });
  return CalendarWeekViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarWeekModule = /*#__PURE__*/(() => {
  class CalendarWeekModule {}
  CalendarWeekModule.ɵfac = function CalendarWeekModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarWeekModule)();
  };
  CalendarWeekModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalendarWeekModule
  });
  CalendarWeekModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, ResizableModule, DragAndDropModule, CalendarCommonModule, ResizableModule, DragAndDropModule]
  });
  return CalendarWeekModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Shows all events on a given day. Example usage:
 *
 * ```typescript
 * <mwl-calendar-day-view
 *  [viewDate]="viewDate"
 *  [events]="events">
 * </mwl-calendar-day-view>
 * ```
 */
let CalendarDayViewComponent = /*#__PURE__*/(() => {
  class CalendarDayViewComponent {
    constructor() {
      /**
       * An array of events to display on view
       * The schema is available here: https://github.com/mattlewis92/calendar-utils/blob/c51689985f59a271940e30bc4e2c4e1fee3fcb5c/src/calendarUtils.ts#L49-L63
       */
      this.events = [];
      /**
       * The number of segments in an hour. Must divide equally into 60.
       */
      this.hourSegments = 2;
      /**
       * The height in pixels of each hour segment
       */
      this.hourSegmentHeight = 30;
      /**
       * The minimum height in pixels of each event
       */
      this.minimumEventHeight = 30;
      /**
       * The day start hours in 24 hour time. Must be 0-23
       */
      this.dayStartHour = 0;
      /**
       * The day start minutes. Must be 0-59
       */
      this.dayStartMinute = 0;
      /**
       * The day end hours in 24 hour time. Must be 0-23
       */
      this.dayEndHour = 23;
      /**
       * The day end minutes. Must be 0-59
       */
      this.dayEndMinute = 59;
      /**
       * The placement of the event tooltip
       */
      this.tooltipPlacement = 'auto';
      /**
       * Whether to append tooltips to the body or next to the trigger element
       */
      this.tooltipAppendToBody = true;
      /**
       * The delay in milliseconds before the tooltip should be displayed. If not provided the tooltip
       * will be displayed immediately.
       */
      this.tooltipDelay = null;
      /**
       * Whether to snap events to a grid when dragging
       */
      this.snapDraggedEvents = true;
      /**
       * Called when an event title is clicked
       */
      this.eventClicked = new EventEmitter();
      /**
       * Called when an hour segment is clicked
       */
      this.hourSegmentClicked = new EventEmitter();
      /**
       * Called when an event is resized or dragged and dropped
       */
      this.eventTimesChanged = new EventEmitter();
      /**
       * An output that will be called before the view is rendered for the current day.
       * If you add the `cssClass` property to an hour grid segment it will add that class to the hour segment in the template
       */
      this.beforeViewRender = new EventEmitter();
    }
  }
  CalendarDayViewComponent.ɵfac = function CalendarDayViewComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarDayViewComponent)();
  };
  CalendarDayViewComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalendarDayViewComponent,
    selectors: [["mwl-calendar-day-view"]],
    inputs: {
      viewDate: "viewDate",
      events: "events",
      hourSegments: "hourSegments",
      hourSegmentHeight: "hourSegmentHeight",
      hourDuration: "hourDuration",
      minimumEventHeight: "minimumEventHeight",
      dayStartHour: "dayStartHour",
      dayStartMinute: "dayStartMinute",
      dayEndHour: "dayEndHour",
      dayEndMinute: "dayEndMinute",
      refresh: "refresh",
      locale: "locale",
      eventSnapSize: "eventSnapSize",
      tooltipPlacement: "tooltipPlacement",
      tooltipTemplate: "tooltipTemplate",
      tooltipAppendToBody: "tooltipAppendToBody",
      tooltipDelay: "tooltipDelay",
      hourSegmentTemplate: "hourSegmentTemplate",
      eventTemplate: "eventTemplate",
      eventTitleTemplate: "eventTitleTemplate",
      eventActionsTemplate: "eventActionsTemplate",
      snapDraggedEvents: "snapDraggedEvents",
      allDayEventsLabelTemplate: "allDayEventsLabelTemplate",
      currentTimeMarkerTemplate: "currentTimeMarkerTemplate",
      validateEventTimesChanged: "validateEventTimesChanged",
      resizeCursors: "resizeCursors"
    },
    outputs: {
      eventClicked: "eventClicked",
      hourSegmentClicked: "hourSegmentClicked",
      eventTimesChanged: "eventTimesChanged",
      beforeViewRender: "beforeViewRender"
    },
    standalone: false,
    decls: 1,
    vars: 27,
    consts: [[1, "cal-day-view", 3, "eventClicked", "hourSegmentClicked", "eventTimesChanged", "beforeViewRender", "daysInWeek", "viewDate", "events", "hourSegments", "hourDuration", "hourSegmentHeight", "minimumEventHeight", "dayStartHour", "dayStartMinute", "dayEndHour", "dayEndMinute", "refresh", "locale", "eventSnapSize", "tooltipPlacement", "tooltipTemplate", "tooltipAppendToBody", "tooltipDelay", "resizeCursors", "hourSegmentTemplate", "eventTemplate", "eventTitleTemplate", "eventActionsTemplate", "snapDraggedEvents", "allDayEventsLabelTemplate", "currentTimeMarkerTemplate", "validateEventTimesChanged"]],
    template: function CalendarDayViewComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "mwl-calendar-week-view", 0);
        i0.ɵɵlistener("eventClicked", function CalendarDayViewComponent_Template_mwl_calendar_week_view_eventClicked_0_listener($event) {
          return ctx.eventClicked.emit($event);
        })("hourSegmentClicked", function CalendarDayViewComponent_Template_mwl_calendar_week_view_hourSegmentClicked_0_listener($event) {
          return ctx.hourSegmentClicked.emit($event);
        })("eventTimesChanged", function CalendarDayViewComponent_Template_mwl_calendar_week_view_eventTimesChanged_0_listener($event) {
          return ctx.eventTimesChanged.emit($event);
        })("beforeViewRender", function CalendarDayViewComponent_Template_mwl_calendar_week_view_beforeViewRender_0_listener($event) {
          return ctx.beforeViewRender.emit($event);
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("daysInWeek", 1)("viewDate", ctx.viewDate)("events", ctx.events)("hourSegments", ctx.hourSegments)("hourDuration", ctx.hourDuration)("hourSegmentHeight", ctx.hourSegmentHeight)("minimumEventHeight", ctx.minimumEventHeight)("dayStartHour", ctx.dayStartHour)("dayStartMinute", ctx.dayStartMinute)("dayEndHour", ctx.dayEndHour)("dayEndMinute", ctx.dayEndMinute)("refresh", ctx.refresh)("locale", ctx.locale)("eventSnapSize", ctx.eventSnapSize)("tooltipPlacement", ctx.tooltipPlacement)("tooltipTemplate", ctx.tooltipTemplate)("tooltipAppendToBody", ctx.tooltipAppendToBody)("tooltipDelay", ctx.tooltipDelay)("resizeCursors", ctx.resizeCursors)("hourSegmentTemplate", ctx.hourSegmentTemplate)("eventTemplate", ctx.eventTemplate)("eventTitleTemplate", ctx.eventTitleTemplate)("eventActionsTemplate", ctx.eventActionsTemplate)("snapDraggedEvents", ctx.snapDraggedEvents)("allDayEventsLabelTemplate", ctx.allDayEventsLabelTemplate)("currentTimeMarkerTemplate", ctx.currentTimeMarkerTemplate)("validateEventTimesChanged", ctx.validateEventTimesChanged);
      }
    },
    dependencies: [CalendarWeekViewComponent],
    encapsulation: 2
  });
  return CalendarDayViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarDayModule = /*#__PURE__*/(() => {
  class CalendarDayModule {}
  CalendarDayModule.ɵfac = function CalendarDayModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarDayModule)();
  };
  CalendarDayModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalendarDayModule
  });
  CalendarDayModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, CalendarCommonModule, CalendarWeekModule]
  });
  return CalendarDayModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The main module of this library. Example usage:
 *
 * ```typescript
 * import { CalenderModule } from 'angular-calendar';
 *
 * @NgModule({
 *   imports: [
 *     CalenderModule.forRoot()
 *   ]
 * })
 * class MyModule {}
 * ```
 *
 */
let CalendarModule = /*#__PURE__*/(() => {
  class CalendarModule {
    static forRoot(dateAdapter, config = {}) {
      return {
        ngModule: CalendarModule,
        providers: [dateAdapter, config.eventTitleFormatter || CalendarEventTitleFormatter, config.dateFormatter || CalendarDateFormatter, config.utils || CalendarUtils, config.a11y || CalendarA11y]
      };
    }
  }
  CalendarModule.ɵfac = function CalendarModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalendarModule)();
  };
  CalendarModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalendarModule
  });
  CalendarModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CalendarCommonModule, CalendarMonthModule, CalendarWeekModule, CalendarDayModule, CalendarCommonModule, CalendarMonthModule, CalendarWeekModule, CalendarDayModule]
  });
  return CalendarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of angular-calendar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CalendarA11y, CalendarAngularDateFormatter, CalendarCommonModule, CalendarDateFormatter, CalendarDayModule, CalendarDayViewComponent, CalendarEventTimesChangedEventType, CalendarEventTitleFormatter, CalendarModule, CalendarMomentDateFormatter, CalendarMonthModule, CalendarMonthViewComponent, CalendarNativeDateFormatter, CalendarUtils, CalendarView, CalendarWeekModule, CalendarWeekViewComponent, DateAdapter, MOMENT, collapseAnimation, getWeekViewPeriod, CalendarA11yPipe as ɵCalendarA11yPipe, CalendarDatePipe as ɵCalendarDatePipe, CalendarEventActionsComponent as ɵCalendarEventActionsComponent, CalendarEventTitleComponent as ɵCalendarEventTitleComponent, CalendarEventTitlePipe as ɵCalendarEventTitlePipe, CalendarMonthCellComponent as ɵCalendarMonthCellComponent, CalendarMonthViewHeaderComponent as ɵCalendarMonthViewHeaderComponent, CalendarNextViewDirective as ɵCalendarNextViewDirective, CalendarOpenDayEventsComponent as ɵCalendarOpenDayEventsComponent, CalendarPreviousViewDirective as ɵCalendarPreviousViewDirective, CalendarTodayDirective as ɵCalendarTodayDirective, CalendarTooltipDirective as ɵCalendarTooltipDirective, CalendarTooltipWindowComponent as ɵCalendarTooltipWindowComponent, CalendarWeekViewCurrentTimeMarkerComponent as ɵCalendarWeekViewCurrentTimeMarkerComponent, CalendarWeekViewEventComponent as ɵCalendarWeekViewEventComponent, CalendarWeekViewHeaderComponent as ɵCalendarWeekViewHeaderComponent, CalendarWeekViewHourSegmentComponent as ɵCalendarWeekViewHourSegmentComponent, ClickDirective as ɵClickDirective, KeydownEnterDirective as ɵKeydownEnterDirective };

